/* SPARC Shared V42.7
 * Complete replacement for sparc-muscle-configurator-v7.js.
 * Fix: shared upload/accessory IDs must not suppress Muscle pages.
 * Driver, Garage and Heritage retain their dedicated configurators.
 */

(function () {
  "use strict";

  if (window.__SPARC_MUSCLE_V10_LOADED__) {
    return;
  }

  window.__SPARC_MUSCLE_V10_LOADED__ = true;

  var IDS = {
    finish: "sparc-muscle-finish",
    grip: "sparc-muscle-grip",
    leatherWrap: "sparc-shared-leather-wrap",
    leatherColor: "sparc-muscle-leather-color",
    leatherTemplate: "sparc-muscle-leather-template",
    stitching: "sparc-shared-stitching",
    hornLogo: "sparc-shared-horn-logo",
    adapter: "sparc-muscle-adapter",
    hubSleeve: "sparc-muscle-hub-sleeve",
    columnSpacer: "sparc-muscle-column-spacer",
    columnSpacerFinish: "sparc-muscle-column-spacer-finish",
    careKit: "sparc-shared-care-kit"
  };

  var CORE_REF_KEYS = ["finish"];

  var STITCH_COLORS = {
    Black: "#151515",
    Red: "#b62323",
    White: "#efefef",
    Silver: "#a4a4a4",
    Gray: "#6f6f6f",
    Gold: "#c7a32b",
    Tan: "#b99a74",
    Brown: "#765038",
    "Dark Brown": "#402b22",
    "Dark Blue": "#263e6d",
    "Lime Green": "#82c341",
    Purple: "#673a78"
  };

  var FRIENDLY = {
    "None (raw finish)": "No Leather",
    "Sparc Logo": "SPARC Logo",
    "Sparc Logo Delete": "Logo Delete"
  };

  var refs = {};
  var panel = null;
  var sourceHost = null;
  var accs = {};
  var tabs = {};
  var syncPending = false;
  var syncTimer = null;
  var resizeTimer = null;

  function q(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qa(sel, root) {
    return Array.prototype.slice.call(
      (root || document).querySelectorAll(sel)
    );
  }

  function clean(s) {
    return String(s || "").replace(/\s+/g, " ").trim();
  }

  function friendly(v) {
    if (!v) {
      return "Not selected";
    }

    var display = FRIENDLY[v] || v;

    display = String(display)
      .replace(/\s*\[\s*[+\-]?\$[\d,]+(?:\.\d{1,2})?\s*\]\s*/g, " ")
      .replace(/\s*\|\s*[+\-]?\$[\d,]+(?:\.\d{1,2})?\s*\|\s*/g, " ")
      .replace(/\s*\(\s*[+\-]?\$[\d,]+(?:\.\d{1,2})?\s*\)\s*/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    return display;
  }

  function normalizeAccessoryValue(value) {
    return friendly(value)
      .replace(/[\u201C\u201D\u2033]/g, '"')
      .replace(/[\u2018\u2019\u2032]/g, "'")
      .toLowerCase()
      .trim();
  }

  function valueEquals(value, expected) {
    var left = normalizeAccessoryValue(value);
    var right = normalizeAccessoryValue(expected);

    return left === right;
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);

    if (cls) {
      node.className = cls;
    }

    if (text !== undefined && text !== null) {
      node.textContent = text;
    }

    return node;
  }

  var ROLE_NAMES = {
    finish: "finish",
    grip: "grip",
    leatherWrap: "leather-wrap",
    leatherColor: "leather-color",
    leatherTemplate: "leather-template",
    stitching: "stitching",
    hornLogo: "horn-logo",
    adapter: "adapter",
    hubSleeve: "hub-sleeve",
    columnSpacer: "column-spacer",
    columnSpacerFinish: "column-spacer-finish",
    careKit: "care-kit"
  };

  var ROLE_SECTIONS = {
    finish: "finish",
    grip: "grip",
    leatherWrap: "leather",
    leatherColor: "leather",
    leatherTemplate: "leather",
    stitching: "leather",
    hornLogo: "horn",
    adapter: "mounting",
    hubSleeve: "mounting",
    columnSpacer: "accessories",
    columnSpacerFinish: "accessories",
    careKit: "accessories"
  };

  var sourceGroups = {};
  var sourceRoots = [];
  var extraFields = new Map();
  var sourceTokens = new WeakMap();
  var sourceSerial = 0;
  var sharedMounts = {};
  var sharedSettings = window.SPARC_CONFIGURATOR || {};

  function sourceToken(root) {
    if (!root) {
      return "";
    }

    if (!sourceTokens.has(root)) {
      sourceTokens.set(root, "source-" + ++sourceSerial);
    }

    return sourceTokens.get(root);
  }

  function sourceRole(root) {
    var keys = Object.keys(ROLE_NAMES);

    var explicit = keys.find(function (key) {
      return root.classList.contains("sparc-role-" + ROLE_NAMES[key]);
    });

    if (explicit) {
      return explicit;
    }

    var configured = keys.find(function (key) {
      var ids = sharedSettings.ids && sharedSettings.ids[key];

      return ids && [].concat(ids).indexOf(root.id) !== -1;
    });

    if (configured) {
      return configured;
    }

    var ordered = keys.slice().sort(function (a, b) {
      return ROLE_NAMES[b].length - ROLE_NAMES[a].length;
    });

    var matched = ordered.find(function (key) {
      return (
        root.id === IDS[key] ||
        new RegExp(
          "^sparc-(?:muscle|shared|heritage|classic|driver|garage)-" +
          ROLE_NAMES[key] +
          "(?:$|-)"
        ).test(root.id)
      );
    });

    if (matched) {
      return matched;
    }

    var name = q(".hulkapps_option_name", root);
    var label = clean(name && name.getAttribute("aria-label")).toLowerCase();

    if (/^(laser marking\??|horn logo\??)$/.test(label)) {
      return "hornLogo";
    }

    if (/^stitching(?: color)?(?:\??$|\s*[-–—:])/.test(label)) {
      return "stitching";
    }

    return "";
  }

  function refreshRefs() {
    var scope = sourceHost && sourceHost.isConnected
      ? sourceHost
      : document;

    sourceRoots = qa(".hulkapps_option", scope).filter(function (node) {
      return !panel || !panel.contains(node);
    });

    if (sourceHost && !sourceHost.isConnected && sourceRoots.length) {
      sourceHost =
        sourceRoots[0].closest(".hulkapps_option_set") ||
        sourceRoots[0].parentElement;
    }

    qa(".sparc-config-option", scope).forEach(function (node) {
      if (
        (!panel || !panel.contains(node)) &&
        sourceRoots.indexOf(node) < 0 &&
        !sourceRoots.some(function (root) {
          return root.contains(node);
        })
      ) {
        sourceRoots.push(node);
      }
    });

    Object.keys(IDS).forEach(function (key) {
      sourceGroups[key] = [];
    });

    sourceRoots.forEach(function (root) {
      var role = sourceRole(root);

      if (role) {
        sourceGroups[role].push(root);
      }
    });

    Object.keys(IDS).forEach(function (key) {
      var active = sourceGroups[key].filter(sourceVisible);
      refs[key] = active.length === 1 ? active[0] : null;
    });
  }

  function allRefsPresent() {
    refreshRefs();

    return CORE_REF_KEYS.filter(function (key) {
      return !sourceGroups[key].length;
    });
  }

  function liveSource(root) {
    if (!root) {
      return null;
    }

    refreshRefs();

    var role = sourceRole(root);

    var live = role
      ? refs[role]
      : sourceRoots.find(function (node) {
          return (
            node === root ||
            (
              root.getAttribute("data-parent-id") &&
              node.getAttribute("data-parent-id") ===
                root.getAttribute("data-parent-id")
            )
          );
        });

    if (!live || !sourceVisible(live)) {
      return null;
    }

    if (
      live !== root &&
      (
        !root.getAttribute("data-parent-id") ||
        live.getAttribute("data-parent-id") !==
          root.getAttribute("data-parent-id")
      )
    ) {
      return null;
    }

    return live;
  }

  function sourceSelect(root) {
    if (!root) {
      return null;
    }

    return root.tagName === "SELECT" ? root : q("select", root);
  }

  function sourceInputs(root) {
    if (!root) {
      return [];
    }

    if (
      root.matches &&
      root.matches('input[type="radio"],input[type="checkbox"]')
    ) {
      return [root];
    }

    return qa('input[type="radio"],input[type="checkbox"]', root);
  }

  function sourceVisible(root) {
    if (!root || !root.isConnected) {
      return false;
    }

    for (
      var parent = root;
      parent && parent !== document.body;
      parent = parent.parentElement
    ) {
      var style = getComputedStyle(parent);

      if (
        style.display === "none" ||
        style.visibility === "hidden" ||
        parent.hidden === true ||
        parent.getAttribute("aria-hidden") === "true"
      ) {
        return false;
      }
    }

    return true;
  }

  function labelForInput(input, root) {
    if (input && input.id) {
      try {
        var label = document.querySelector(
          'label[for="' + CSS.escape(input.id) + '"]'
        );

        if (label) {
          return label;
        }
      } catch (error) {}
    }

    return input ? input.closest("label") || q("label", root) : null;
  }

  function choiceContainer(input, root) {
    for (
      var parent = input, index = 0;
      index < 5 && parent && parent !== root;
      index++, parent = parent.parentElement
    ) {
      if (q("img", parent)) {
        return parent;
      }
    }

    return labelForInput(input, root) || (input && input.parentElement);
  }

  function cssUrl(value) {
    if (!value || value === "none") {
      return "";
    }

    var match = String(value).match(/url\((['"]?)(.*?)\1\)/i);

    return match ? match[2] : "";
  }

  function pseudoMediaUrl(node, pseudo) {
    if (!node) {
      return "";
    }

    try {
      var style = getComputedStyle(node, pseudo);
      return cssUrl(style && style.backgroundImage);
    } catch (error) {
      return "";
    }
  }

  function mediaUrl(node) {
    if (!node) {
      return "";
    }

    if (node.tagName === "IMG") {
      return (
        node.currentSrc ||
        node.src ||
        node.getAttribute("data-src") ||
        node.getAttribute("data-lazy-src") ||
        node.getAttribute("data-original") ||
        ""
      );
    }

    var attributes = [
      "data-src",
      "data-image",
      "data-image-url",
      "data-original",
      "data-lazy-src",
      "data-bg",
      "data-background"
    ];

    for (var index = 0; index < attributes.length; index++) {
      var value = node.getAttribute && node.getAttribute(attributes[index]);

      if (value && /^https?:|^\/|^\/\//.test(value)) {
        return value;
      }
    }

    var url = cssUrl(node.style && node.style.backgroundImage);

    if (url) {
      return url;
    }

    try {
      url = cssUrl(getComputedStyle(node).backgroundImage);

      if (url) {
        return url;
      }
    } catch (error) {}

    return "";
  }

  function isUtilityIcon(node) {
    var descriptor = (
      (node.className || "") + " " +
      (node.id || "") + " " +
      (node.getAttribute && node.getAttribute("alt") || "") + " " +
      (node.getAttribute && node.getAttribute("title") || "")
    ).toLowerCase();

    return /tooltip|info|question|help|icon-info|fa-info/.test(descriptor);
  }

  function mediaCandidates(scope) {
    if (!scope) {
      return [];
    }

    var nodes = [scope].concat(
      qa(
        "img,[style*='background'],[data-src],[data-image]," +
        "[data-image-url],[data-original],[data-lazy-src]," +
        "[data-bg],[data-background]",
        scope
      )
    );

    var results = [];

    nodes.forEach(function (node) {
      if (!node || isUtilityIcon(node)) {
        return;
      }

      var urls = [
        mediaUrl(node),
        pseudoMediaUrl(node, "::before"),
        pseudoMediaUrl(node, "::after")
      ].filter(Boolean);

      urls.forEach(function (url) {
        var lower = String(url).toLowerCase();

        if (/tooltip|info-icon|question|help-icon|icon-info/.test(lower)) {
          return;
        }

        if (!results.some(function (item) {
          return item.url === url;
        })) {
          results.push({
            node: node,
            url: url
          });
        }
      });
    });

    return results;
  }

  function scopeHasSingleChoice(scope, root) {
    if (!scope) {
      return false;
    }

    if (sourceInputs(scope).length === 1) {
      return true;
    }

    var inside = sourceInputs(root).filter(function (input) {
      return scope.contains(input);
    });

    return inside.length === 1;
  }

  function exactChoiceScopes(input, root) {
    var scopes = [];

    function add(node) {
      if (
        node &&
        node !== document.body &&
        scopes.indexOf(node) === -1
      ) {
        scopes.push(node);
      }
    }

    add(labelForInput(input, root));

    if (input) {
      add(input.parentElement);
      add(input.previousElementSibling);
      add(input.nextElementSibling);

      if (input.parentElement) {
        add(input.parentElement.previousElementSibling);
        add(input.parentElement.nextElementSibling);
      }
    }

    for (
      var parent = input ? input.parentElement : null, index = 0;
      index < 6 && parent && parent !== root && parent !== document.body;
      index++, parent = parent.parentElement
    ) {
      if (scopeHasSingleChoice(parent, root)) {
        add(parent);
      }
    }

    return scopes;
  }

  function bestMediaFromScope(scope) {
    var candidates = mediaCandidates(scope);

    if (!candidates.length) {
      return "";
    }

    function score(item) {
      var node = item.node;
      var value = 0;

      if (node && node.tagName === "IMG") {
        value += 100;
      }

      var descriptor = (
        (node && node.className || "") + " " +
        (node && node.id || "")
      ).toLowerCase();

      if (/swatch|image|img|option|thumbnail|thumb/.test(descriptor)) {
        value += 25;
      }

      if (node && node.getBoundingClientRect) {
        var rect = node.getBoundingClientRect();

        if (rect.width >= 25 && rect.height >= 25) {
          value += 10;
        }
      }

      return value;
    }

    candidates.sort(function (a, b) {
      return score(b) - score(a);
    });

    return candidates[0].url || "";
  }

  function findMediaForInput(input, root) {
    var scopes = exactChoiceScopes(input, root);

    for (var index = 0; index < scopes.length; index++) {
      var url = bestMediaFromScope(scopes[index]);

      if (url) {
        return url;
      }
    }

    return "";
  }

  function findMediaForValue(root, value) {
    var inputs = sourceInputs(root);

    if (inputs.length) {
      var input = inputs.find(function (item) {
        return String(item.value) === String(value);
      });

      if (input) {
        return findMediaForInput(input, root);
      }
    }

    return "";
  }

  function parsePrice(text) {
    var match = String(text || "").match(
      /([+\-]?\s*\$\s*[\d,]+(?:\.\d{1,2})?)/
    );

    if (!match) {
      return "";
    }

    var value = match[1].replace(/\s+/g, "");
    var amount = parseFloat(value.replace(/[+$,]/g, ""));

    if (!isNaN(amount) && amount === 0) {
      return "Included";
    }

    if (value.charAt(0) === "$") {
      value = "+" + value;
    }

    return value;
  }

  function choices(root) {
    if (!root) {
      return [];
    }

    var select = sourceSelect(root);

    if (select) {
      return qa("option", select).filter(function (option) {
        return option.value !== "";
      }).map(function (option) {
        return {
          value: option.value,
          label: option.value,
          price: parsePrice(option.textContent),
          image: findMediaForValue(root, option.value),
          disabled: !!(select.disabled || option.disabled),
          selected: option.selected
        };
      });
    }

    return sourceInputs(root).map(function (input) {
      var container = choiceContainer(input, root);

      return {
        value: input.value,
        label: input.value,
        price: parsePrice(container && container.textContent),
        image: findMediaForValue(root, input.value),
        disabled: !!input.disabled,
        selected: !!input.checked
      };
    });
  }

  function current(root) {
    if (!root || !sourceVisible(root)) {
      return "";
    }

    var select = sourceSelect(root);

    if (select) {
      return select.value || "";
    }

    return sourceInputs(root).filter(function (input) {
      return input.checked;
    }).map(function (input) {
      return input.value;
    }).join(" · ");
  }

  function setSelectChoice(select, wanted) {
    if (!select) {
      return false;
    }

    var wantedNormalized = normalizeAccessoryValue(wanted);
    var options = qa("option", select);

    var match = options.find(function (option) {
      return normalizeAccessoryValue(option.value) === wantedNormalized;
    });

    if (!match) {
      match = options.find(function (option) {
        var text = normalizeAccessoryValue(option.textContent);

        return (
          text === wantedNormalized ||
          text.indexOf(wantedNormalized + " ") === 0 ||
          text.indexOf(wantedNormalized + "+") === 0
        );
      });
    }

    if (!match || select.disabled || match.disabled) {
      return false;
    }

    options.forEach(function (option) {
      option.selected = option === match;
    });

    select.selectedIndex = options.indexOf(match);
    select.dispatchEvent(new Event("input", { bubbles: true }));
    select.dispatchEvent(new Event("change", { bubbles: true }));

    if (window.jQuery && typeof window.jQuery === "function") {
      try {
        window.jQuery(select).trigger("change");
      } catch (error) {}
    }

    delayedSync();
    return true;
  }

  function choose(root, value) {
    root = liveSource(root);

    if (!root) {
      queueSync();
      return;
    }

    var select = sourceSelect(root);

    if (select) {
      setSelectChoice(select, value);
      return;
    }

    var input = sourceInputs(root).find(function (item) {
      return String(item.value) === String(value);
    });

    if (input && !input.disabled) {
      if (input.type === "checkbox" || !input.checked) {
        input.click();
      }

      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
      delayedSync();
    }
  }

  var LASER_TICKET_NAME = "properties[Laser Marking?]";
  var ticketBridgeError = "";
  var ticketBridgeLastWarning = "";

  function productOptionForm() {
    return (
      (sourceHost && sourceHost.closest("form")) ||
      (refs.finish && refs.finish.closest("form")) ||
      null
    );
  }

  function hornPropertyName(root) {
    var property = qa(
      "input[name],select[name],textarea[name]",
      root
    ).find(function (node) {
      return /^properties\[(?!_).+\]$/.test(node.name);
    });

    if (property) {
      return property.name;
    }

    var title = q(".hulkapps_option_name", root);
    var label = clean(
      title && (title.getAttribute("aria-label") || title.textContent)
    );

    return label ? "properties[" + label + "]" : "";
  }

  function ticketLogoValue(root) {
    if (!root || !sourceVisible(root)) {
      return "";
    }

    var select = sourceSelect(root);

    var selected = select
      ? select.options[select.selectedIndex]
      : sourceInputs(root).find(function (node) {
          return node.checked && !node.disabled;
        });

    if (!selected || selected.disabled || (select && select.disabled)) {
      return "";
    }

    var choice = selected.closest("[data-conditional-value]");

    var value = choice && root.contains(choice)
      ? choice.getAttribute("data-conditional-value")
      : selected.value;

    return clean(
      String(value || "")
        .replace(/\s*\[\s*[+\-]?\$[\d,]+(?:\.\d{1,2})?\s*\]\s*/g, " ")
        .replace(/\s*\|\s*[+\-]?\$[\d,]+(?:\.\d{1,2})?\s*\|\s*/g, " ")
        .replace(/\s*\(\s*[+\-]?\$[\d,]+(?:\.\d{1,2})?\s*\)\s*/g, " ")
    );
  }

  function syncLaserMarkingTicket() {
    var groups = sourceGroups.hornLogo || [];
    var form = productOptionForm();
    var mirror = form && q('input[data-sparc-laser-ticket="true"]', form);
    var names = groups.map(hornPropertyName);

    ticketBridgeError = "";

    var nativeTicket =
      groups.length === 1 && names[0] === LASER_TICKET_NAME;

    if (!groups.length || nativeTicket) {
      if (mirror) {
        mirror.remove();
      }

      return true;
    }

    if (
      names.some(function (name, index) {
        return !name || names.indexOf(name) !== index;
      }) ||
      names.indexOf(LASER_TICKET_NAME) !== -1
    ) {
      ticketBridgeError =
        "Give every horn inventory option a distinct Hulk Display Name. " +
        "Reserve Laser Marking? for the ticket bridge; keep Unique Names, " +
        "IDs, values, conditions, and linked variants unchanged.";
    } else if (!form) {
      ticketBridgeError =
        "The horn options must belong to the product Add to Cart form.";
    } else if (
      qa("input[name],select[name],textarea[name]", form).some(function (node) {
        return node.name === LASER_TICKET_NAME && node !== mirror;
      })
    ) {
      ticketBridgeError =
        "An additional Laser Marking? form property conflicts with the ticket bridge.";
    }

    if (ticketBridgeError) {
      if (mirror) {
        if (mirror.value) {
          mirror.value = "";
        }

        if (!mirror.disabled) {
          mirror.disabled = true;
        }
      }

      if (ticketBridgeLastWarning !== ticketBridgeError) {
        console.warn("[SPARC Shared V42.7] " + ticketBridgeError);
        ticketBridgeLastWarning = ticketBridgeError;
      }

      return false;
    }

    ticketBridgeLastWarning = "";

    if (!mirror) {
      mirror = document.createElement("input");
      mirror.type = "hidden";
      mirror.name = LASER_TICKET_NAME;
      mirror.setAttribute("data-sparc-laser-ticket", "true");
      form.appendChild(mirror);
    }

    var value = ticketLogoValue(refs.hornLogo);

    if (mirror.value !== value) {
      mirror.value = value;
    }

    if (mirror.disabled !== !value) {
      mirror.disabled = !value;
    }

    return true;
  }

  var STITCH_TICKET_NAME = "properties[Stitching]";
  var stitchTicketError = "";
  var stitchTicketLastWarning = "";

  function syncStitchingTicket() {
    var groups = sourceGroups.stitching || [];
    var form = productOptionForm();
    var mirror = form && q('input[data-sparc-stitch-ticket="true"]', form);
    var names = groups.map(hornPropertyName);

    stitchTicketError = "";

    var nativeTicket =
      groups.length === 1 && names[0] === STITCH_TICKET_NAME;

    if (!groups.length || nativeTicket) {
      if (mirror) {
        mirror.remove();
      }

      return true;
    }

    if (
      names.some(function (name, index) {
        return !name || names.indexOf(name) !== index;
      }) ||
      names.indexOf(STITCH_TICKET_NAME) !== -1
    ) {
      stitchTicketError =
        "Give every stitching inventory option a distinct Hulk Display Name. " +
        "Reserve Stitching for the ticket bridge; keep Unique Names, IDs, " +
        "values, conditions, and linked variants unchanged.";
    } else if (!form) {
      stitchTicketError =
        "The stitching options must belong to the product Add to Cart form.";
    } else if (
      qa("input[name],select[name],textarea[name]", form).some(function (node) {
        return node.name === STITCH_TICKET_NAME && node !== mirror;
      })
    ) {
      stitchTicketError =
        "An additional Stitching form property conflicts with the ticket bridge.";
    }

    if (stitchTicketError) {
      if (mirror) {
        if (mirror.value) {
          mirror.value = "";
        }

        if (!mirror.disabled) {
          mirror.disabled = true;
        }
      }

      if (stitchTicketLastWarning !== stitchTicketError) {
        console.warn("[SPARC Shared V42.7] " + stitchTicketError);
        stitchTicketLastWarning = stitchTicketError;
      }

      return false;
    }

    stitchTicketLastWarning = "";

    if (!mirror) {
      mirror = document.createElement("input");
      mirror.type = "hidden";
      mirror.name = STITCH_TICKET_NAME;
      mirror.setAttribute("data-sparc-stitch-ticket", "true");
      form.appendChild(mirror);
    }

    var ready =
      (!refs.leatherWrap || isYesValue(current(refs.leatherWrap))) &&
      (
        !(sourceGroups.leatherColor || []).length ||
        !!current(refs.leatherColor)
      );

    var value = ready ? ticketLogoValue(refs.stitching) : "";

    if (mirror.value !== value) {
      mirror.value = value;
    }

    if (mirror.disabled !== !value) {
      mirror.disabled = !value;
    }

    return true;
  }

  var BUILD_TICKET_FIELDS = {
    finish: "Steering Wheel Finish",
    grip: "Grip Style",
    adapter: "Adapter",
    hubSleeve: "Include Hub Sleeve?"
  };

  var buildTicketErrors = {};
  var buildTicketLastWarning = "";

  function syncBuildTickets() {
    var form = productOptionForm();
    buildTicketErrors = {};

    Object.keys(BUILD_TICKET_FIELDS).forEach(function (role) {
      var groups = sourceGroups[role] || [];
      var ticketName = "properties[" + BUILD_TICKET_FIELDS[role] + "]";

      var mirror = form && q(
        'input[data-sparc-build-ticket="' + role + '"]',
        form
      );

      var names = groups.map(hornPropertyName);

      if (
        !groups.length ||
        (groups.length === 1 && names[0] === ticketName)
      ) {
        if (mirror) {
          mirror.remove();
        }

        return;
      }

      var error = "";

      if (
        names.some(function (name, index) {
          return !name || names.indexOf(name) !== index;
        }) ||
        names.indexOf(ticketName) !== -1
      ) {
        error =
          "Give each " + role +
          " inventory option a distinct Hulk Display Name. Reserve " +
          BUILD_TICKET_FIELDS[role] +
          " for the ticket copy. Keep IDs, values, conditions, " +
          "and linked variants unchanged.";
      } else if (
        !form ||
        groups.some(function (root) {
          return root.closest("form") !== form;
        })
      ) {
        error =
          "The " + role +
          " inventory options must belong to the product Add to Cart form.";
      } else if (
        qa("input[name],select[name],textarea[name]", form).some(function (node) {
          return node.name === ticketName && node !== mirror;
        })
      ) {
        error =
          "An additional " + BUILD_TICKET_FIELDS[role] +
          " form property conflicts with the ticket copy.";
      }

      if (error) {
        buildTicketErrors[role] = error;

        if (mirror) {
          if (mirror.value) {
            mirror.value = "";
          }

          if (!mirror.disabled) {
            mirror.disabled = true;
          }
        }

        return;
      }

      if (!mirror) {
        mirror = document.createElement("input");
        mirror.type = "hidden";
        mirror.name = ticketName;
        mirror.setAttribute("data-sparc-build-ticket", role);
        form.appendChild(mirror);
      }

      var value = ticketLogoValue(refs[role]);

      if (mirror.value !== value) {
        mirror.value = value;
      }

      if (mirror.disabled !== !value) {
        mirror.disabled = !value;
      }
    });

    var warning = Object.keys(buildTicketErrors).map(function (role) {
      return buildTicketErrors[role];
    }).join(" ");

    if (warning && warning !== buildTicketLastWarning) {
      console.warn("[SPARC Shared V42.7] " + warning);
    }

    buildTicketLastWarning = warning;

    return !warning;
  }

  function orderTicketFields() {
    var form = productOptionForm();

    if (!form) {
      return;
    }

    var fields = [
      ["finish", "Steering Wheel Finish"],
      ["grip", "Grip Style"],
      ["leatherWrap", "Leather Wrap?"],
      ["leatherColor", "Leather Color"],
      ["stitching", "Stitching"],
      ["leatherTemplate", "Leather Template?"],
      ["hornLogo", "Laser Marking?"],
      ["adapter", "Adapter"],
      ["hubSleeve", "Include Hub Sleeve?"]
    ];

    var anchor = null;

    fields.slice().reverse().forEach(function (field) {
      var role = field[0];
      var name = "properties[" + field[1] + "]";

      var mirror = qa("input[name]", form).find(function (node) {
        return (
          node.name === name &&
          (
            node.hasAttribute("data-sparc-build-ticket") ||
            node.hasAttribute("data-sparc-laser-ticket") ||
            node.hasAttribute("data-sparc-stitch-ticket")
          )
        );
      });

      if (mirror) {
        var parent = anchor ? anchor.parentNode : form;

        if (mirror.parentNode !== parent || mirror.nextSibling !== anchor) {
          parent.insertBefore(mirror, anchor);
        }

        anchor = mirror;
      } else {
        var native = (sourceGroups[role] || []).find(function (root) {
          return (
            root.closest("form") === form &&
            hornPropertyName(root) === name
          );
        });

        if (native) {
          anchor = native;
        }
      }
    });
  }

  function getState() {
    return {
      finish: current(refs.finish),
      grip: current(refs.grip),
      leatherWrap: current(refs.leatherWrap),
      leatherColor: current(refs.leatherColor),
      leatherTemplate: current(refs.leatherTemplate),
      stitching: current(refs.stitching),
      hornLogo: current(refs.hornLogo),
      adapter: current(refs.adapter),
      hubSleeve: current(refs.hubSleeve),
      columnSpacer: current(refs.columnSpacer),
      columnSpacerFinish: current(refs.columnSpacerFinish),
      careKit: current(refs.careKit)
    };
  }

  function configuredPrice() {
    var text = (document.body.innerText || "").replace(/\u00a0/g, " ");
    var matches = text.match(/Total price is\s*\$[\d,]+(?:\.\d{2})?/gi);

    if (matches && matches.length) {
      var last = matches[matches.length - 1];
      var price = last.match(/\$[\d,]+(?:\.\d{2})?/);

      if (price) {
        return price[0];
      }
    }

    return "—";
  }

  function leadDebugEnabled() {
    try {
      return new URLSearchParams(window.location.search)
        .get("sparc_lead_debug") === "1";
    } catch (error) {
      return false;
    }
  }

  function ruleDebugRow(rule) {
    if (!rule) {
      return null;
    }

    return {
      ruleName: rule.ruleName,
      scope: rule.seriesScope,
      productHandle: rule.productHandle,
      selectorId: rule.selectorId,
      optionValue: rule.optionValue,
      normalizedValue: normalizeRuleValue(rule.optionValue),
      minimum: rule.minimum,
      maximum: rule.maximum,
      unit: rule.unit,
      customerMessage: rule.customerMessage,
      valid: validLeadRule(rule)
    };
  }

  var leadTimeDataCache = null;
  var leadTimeDataMissingLogged = false;

  function leadTimeData() {
    if (leadTimeDataCache) {
      return leadTimeDataCache;
    }

    var node = document.getElementById("sparc-configurator-lead-time-data");

    if (!node) {
      if (!leadTimeDataMissingLogged) {
        leadTimeDataMissingLogged = true;
        console.warn(
          "[SPARC Shared V42.7] Lead-time JSON bridge was not found on the page."
        );
      }

      return null;
    }

    try {
      leadTimeDataCache = JSON.parse(node.textContent || "{}");
      return leadTimeDataCache;
    } catch (error) {
      console.error(
        "[SPARC Shared V42.7] Lead-time JSON could not be parsed.",
        error
      );

      return null;
    }
  }

  function normalizeLeadUnit(unit) {
    var value = String(unit || "").trim().toLowerCase();

    if (value === "day" || value === "days") {
      return "days";
    }

    if (
      value === "week" ||
      value === "weeks" ||
      value === "wk" ||
      value === "wks"
    ) {
      return "weeks";
    }

    return "";
  }

  function normalizeSelectorId(value) {
    return String(value || "")
      .replace(/\u00a0/g, " ")
      .trim()
      .toLowerCase();
  }

  function normalizeRuleValue(value) {
    if (value === null || value === undefined) {
      return "";
    }

    var text = String(value)
      .replace(/\u00a0/g, " ")
      .replace(/&nbsp;/gi, " ");

    text = friendly(text);

    text = String(text)
      .replace(/[[(|]?\s*[+\-]?\s*\$\s*[\d,]+(?:\.\d{1,2})?\s*[\])|]?/g, " ")
      .replace(/\s+[+\-]\s*[\d,]+(?:\.\d{1,2})?\s*$/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

    return text
      .replace(/\s*[|•·]\s*/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function ruleValueMatches(ruleValue, selectedValue) {
    var rule = normalizeRuleValue(ruleValue);
    var selected = normalizeRuleValue(selectedValue);

    if (!rule || !selected) {
      return false;
    }

    return (
      rule === selected ||
      selected.indexOf(rule + " ") === 0 ||
      selected.indexOf(rule + " -") === 0 ||
      selected.indexOf(rule + ":") === 0
    );
  }

  function ruleComparisonDays(rule) {
    var unit = normalizeLeadUnit(rule && rule.unit);
    var minimum = Number(rule && rule.minimum) || 0;
    var maximum = Number(rule && rule.maximum) || 0;

    if (unit === "weeks") {
      minimum *= 7;
      maximum *= 7;
    }

    return {
      min: minimum,
      max: maximum
    };
  }

  function validLeadRule(rule) {
    if (!rule) {
      return false;
    }

    var unit = normalizeLeadUnit(rule.unit);
    var minimum = Number(rule.minimum);
    var maximum = Number(rule.maximum);

    return !!(
      unit &&
      isFinite(minimum) &&
      isFinite(maximum) &&
      minimum >= 0 &&
      maximum >= minimum
    );
  }

  function ruleSpecificity(rule, data) {
    if (!rule || !data) {
      return -1;
    }

    var scope = String(rule.seriesScope || "").toLowerCase();
    var productHandle = String(rule.productHandle || "");

    if (productHandle && productHandle === String(data.productHandle || "")) {
      return 300;
    }

    if (scope && scope === String(data.seriesScope || "").toLowerCase()) {
      return 200;
    }

    return scope === "shared" ? 100 : -1;
  }

  function matchingRule(selectorId, optionValue) {
    var data = leadTimeData();

    if (!data || !Array.isArray(data.rules)) {
      return null;
    }

    var selector = normalizeSelectorId(selectorId);

    var selectorRules = data.rules.filter(function (rule) {
      return (
        validLeadRule(rule) &&
        normalizeSelectorId(rule.selectorId) === selector &&
        ruleSpecificity(rule, data) >= 0
      );
    });

    var matches = selectorRules.filter(function (rule) {
      return ruleValueMatches(rule.optionValue, optionValue);
    });

    if (!matches.length) {
      if (leadDebugEnabled()) {
        console.warn("[SPARC Shared V42.7] No rule match", {
          selectorId: selectorId,
          selectedValue: optionValue,
          normalizedSelector: selector,
          normalizedSelectedValue: normalizeRuleValue(optionValue),
          candidateRules: selectorRules.map(function (rule) {
            return {
              ruleName: rule.ruleName,
              selectorId: rule.selectorId,
              optionValue: rule.optionValue,
              normalizedOptionValue: normalizeRuleValue(rule.optionValue),
              min: rule.minimum,
              max: rule.maximum,
              unit: rule.unit
            };
          })
        });
      }

      return null;
    }

    matches.sort(function (a, b) {
      return ruleSpecificity(b, data) - ruleSpecificity(a, data);
    });

    return matches[0];
  }

  function baseLeadRule() {
    return matchingRule("base", "base");
  }

  function activeLeadSelections(state) {
    var selections = [];

    function push(selectorId, value) {
      if (value) {
        selections.push({
          selectorId: selectorId,
          value: value
        });
      }
    }

    push(refs.finish ? refs.finish.id : IDS.finish, state.finish);
    push(refs.grip ? refs.grip.id : IDS.grip, state.grip);
    push(
      refs.leatherWrap ? refs.leatherWrap.id : IDS.leatherWrap,
      state.leatherWrap
    );

    if (refs.leatherColor && sourceVisible(refs.leatherColor)) {
      push(refs.leatherColor.id, state.leatherColor);
    }

    if (refs.stitching && sourceVisible(refs.stitching)) {
      push(refs.stitching.id, state.stitching);
    }

    if (refs.leatherTemplate && sourceVisible(refs.leatherTemplate)) {
      push(refs.leatherTemplate.id, state.leatherTemplate);
    }

    push(refs.hornLogo ? refs.hornLogo.id : IDS.hornLogo, state.hornLogo);
    push(refs.adapter ? refs.adapter.id : IDS.adapter, state.adapter);

    if (refs.hubSleeve && sourceVisible(refs.hubSleeve)) {
      push(refs.hubSleeve.id, state.hubSleeve);
    }

    if (refs.columnSpacer && sourceVisible(refs.columnSpacer)) {
      push(refs.columnSpacer.id, state.columnSpacer);
    }

    if (refs.columnSpacerFinish && sourceVisible(refs.columnSpacerFinish)) {
      push(refs.columnSpacerFinish.id, state.columnSpacerFinish);
    }

    if (
      refs.careKit &&
      sourceVisible(refs.careKit) &&
      valueEquals(state.careKit, "Yes")
    ) {
      push(refs.careKit.id, state.careKit);
    }

    extraFields.forEach(function (entry, root) {
      if (sourceVisible(root)) {
        push(root.id, current(root));
      }
    });

    return selections;
  }

  function activeLeadMessages(state) {
    var data = leadTimeData();

    if (!data || !Array.isArray(data.rules)) {
      return [];
    }

    var selections = activeLeadSelections(state);
    var messages = [];

    function addMessage(rule) {
      if (!rule) {
        return;
      }

      var message = clean(rule.customerMessage || "");

      if (message && messages.indexOf(message) === -1) {
        messages.push(message);
      }
    }

    selections.forEach(function (selection) {
      var selector = normalizeSelectorId(selection.selectorId);

      data.rules.forEach(function (rule) {
        if (!rule || ruleSpecificity(rule, data) < 0) {
          return;
        }

        if (
          normalizeSelectorId(rule.selectorId) === selector &&
          ruleValueMatches(rule.optionValue, selection.value)
        ) {
          addMessage(rule);
        }
      });
    });

    data.rules.forEach(function (rule) {
      if (!rule || ruleSpecificity(rule, data) < 0) {
        return;
      }

      if (
        normalizeSelectorId(rule.selectorId) === normalizeSelectorId("base") &&
        ruleValueMatches(rule.optionValue, "base")
      ) {
        addMessage(rule);
      }
    });

    if (
      refs.leatherColor &&
      sourceVisible(refs.leatherColor) &&
      normalizeRuleValue(state.leatherColor).indexOf("customer supplied") !== -1
    ) {
      data.rules.forEach(function (rule) {
        if (!rule) {
          return;
        }

        var scope = String(rule.seriesScope || "").trim().toLowerCase();

        if (
          (scope === "shared" || scope === "muscle") &&
          normalizeRuleValue(rule.optionValue).indexOf("customer supplied") !== -1
        ) {
          addMessage(rule);
        }
      });
    }

    return messages;
  }

  function leadQualifier(state) {
    return activeLeadMessages(state).join(" • ");
  }

  function winningLeadRule(state) {
    var candidates = [];
    var base = baseLeadRule();

    if (base) {
      candidates.push(base);
    }

    activeLeadSelections(state).forEach(function (selection) {
      var rule = matchingRule(selection.selectorId, selection.value);

      if (rule) {
        candidates.push(rule);
      }
    });

    if (!candidates.length) {
      return null;
    }

    candidates.sort(function (a, b) {
      var aDays = ruleComparisonDays(a);
      var bDays = ruleComparisonDays(b);

      if (bDays.max !== aDays.max) {
        return bDays.max - aDays.max;
      }

      if (bDays.min !== aDays.min) {
        return bDays.min - aDays.min;
      }

      return (
        ruleSpecificity(b, leadTimeData()) -
        ruleSpecificity(a, leadTimeData())
      );
    });

    return candidates[0];
  }

  function formatLeadRule(rule) {
    if (!validLeadRule(rule)) {
      return "—";
    }

    var minimum = Number(rule.minimum);
    var maximum = Number(rule.maximum);
    var unit = normalizeLeadUnit(rule.unit);

    if (unit === "days") {
      if (minimum === maximum) {
        return minimum === 1 ? "1 DAY" : minimum + " DAYS";
      }

      return minimum + "–" + maximum + " DAYS";
    }

    if (unit === "weeks") {
      if (minimum === maximum) {
        return minimum === 1 ? "1 WK" : minimum + " WKS";
      }

      return minimum + "–" + maximum + " WKS";
    }

    return "—";
  }

  function leadTime(state) {
    var winner = winningLeadRule(state);

    if (winner) {
      return formatLeadRule(winner);
    }

    if (leadTimeData()) {
      console.warn(
        "[SPARC Shared V42.7] Lead-time rules loaded, but no applicable rule " +
        "was found. Check the active Muscle Series Base metaobject."
      );
    }

    return "3–5 DAYS";
  }

  function renderLeadDebug() {
    if (!leadDebugEnabled()) {
      return;
    }

    var existing = document.getElementById("sparc-lead-debug");

    if (existing) {
      existing.remove();
    }

    var data = leadTimeData();
    var state = getState();
    var selections = activeLeadSelections(state);
    var box = el("div", "");

    box.id = "sparc-lead-debug";
    box.style.cssText =
      "margin:12px 0;padding:12px 14px;border:2px solid #a8874a;" +
      "background:#fff8ea;color:#222;font:11px/1.45 Arial,sans-serif;";

    var html = "<strong>SPARC V36 Lead-Time Debug</strong>";

    if (!data) {
      html += "<br><br><b>ERROR:</b> Lead-time JSON bridge is missing from the page.";
    }

    html +=
      "<br><br><b>Winning rule:</b><br><pre style='white-space:pre-wrap'>" +
      JSON.stringify(ruleDebugRow(winningLeadRule(state)), null, 2)
        .replace(/</g, "&lt;") +
      "</pre>";

    html +=
      "<b>Active selections:</b><br><pre style='white-space:pre-wrap'>" +
      JSON.stringify(selections.map(function (selection) {
        var matched = matchingRule(selection.selectorId, selection.value);

        return {
          selectorId: selection.selectorId,
          rawValue: selection.value,
          normalizedValue: normalizeRuleValue(selection.value),
          matchedRule: matched ? ruleDebugRow(matched) : null
        };
      }), null, 2).replace(/</g, "&lt;") +
      "</pre>";

    html +=
      "<b>Loaded rules:</b><br><pre style='white-space:pre-wrap'>" +
      JSON.stringify(
        data && data.rules ? data.rules.map(ruleDebugRow) : [],
        null,
        2
      ).replace(/</g, "&lt;") +
      "</pre>";

    box.innerHTML = html;

    var mount = document.getElementById("sparc-muscle-configurator-mount");

    if (mount && mount.parentNode) {
      mount.parentNode.insertBefore(box, mount);
    }
  }

  var optionDetailDataCache = null;

  function optionDetailData() {
    if (optionDetailDataCache) {
      return optionDetailDataCache;
    }

    var node = document.getElementById("sparc-configurator-option-detail-data");

    if (!node) {
      return null;
    }

    try {
      optionDetailDataCache = JSON.parse(node.textContent || "{}");
      return optionDetailDataCache;
    } catch (error) {
      console.error(
        "[SPARC Shared V42.7] Option-detail JSON could not be parsed.",
        error
      );

      return null;
    }
  }

  function optionDetailSpecificity(detail, data) {
    if (!detail || !data) {
      return -1;
    }

    var scope = String(detail.seriesScope || "").toLowerCase();
    var productHandle = String(detail.productHandle || "");

    if (productHandle && productHandle === String(data.productHandle || "")) {
      return 300;
    }

    if (scope && scope === String(data.seriesScope || "").toLowerCase()) {
      return 200;
    }

    return scope === "shared" ? 100 : -1;
  }

  function matchingOptionDetail(selectorId, optionValue) {
    var data = optionDetailData();

    if (!data || !Array.isArray(data.entries)) {
      return null;
    }

    var selector = normalizeSelectorId(selectorId);

    var matches = data.entries.filter(function (detail) {
      return (
        detail &&
        detail.enabled === true &&
        normalizeSelectorId(detail.selectorId) === selector &&
        ruleValueMatches(detail.optionValue, optionValue) &&
        optionDetailSpecificity(detail, data) >= 0
      );
    });

    if (!matches.length) {
      return null;
    }

    matches.sort(function (a, b) {
      return (
        optionDetailSpecificity(b, data) -
        optionDetailSpecificity(a, data)
      );
    });

    return matches[0];
  }

  function selectorImageForOption(root, value, fallbackImage) {
    var detail = matchingOptionDetail(root && root.id, value);

    return fallbackImage || (detail && detail.selectorImage) || "";
  }

  function popupImagesForOption(root, value, fallbackImage) {
    var detail = matchingOptionDetail(root && root.id, value);
    var images = [];

    if (detail && detail.popupImage) {
      images.push(detail.popupImage);
    } else if (detail && detail.selectorImage) {
      images.push(detail.selectorImage);
    } else if (fallbackImage) {
      images.push(fallbackImage);
    }

    if (detail && Array.isArray(detail.popupAdditionalImages)) {
      detail.popupAdditionalImages.forEach(function (url) {
        if (url && images.indexOf(url) === -1) {
          images.push(url);
        }
      });
    }

    return images;
  }

  function accordion(name, number, title) {
    var section = el("section", "sparc-accordion");
    section.dataset.section = name;

    var head = el("button", "sparc-accordion__head");
    head.type = "button";
    head.appendChild(el("span", "sparc-step-number", number));
    head.appendChild(el("span", "sparc-accordion__title", title));
    head.appendChild(el("span", "sparc-required-badge", "REQUIRED"));
    head.appendChild(el("span", "sparc-accordion__summary", ""));
    head.appendChild(el("span", "sparc-chevron", "⌄"));

    var body = el("div", "sparc-accordion__body");
    var inner = el("div", "sparc-accordion__inner");

    body.appendChild(inner);
    section.appendChild(head);
    section.appendChild(body);

    head.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (section.classList.contains("is-open")) {
        closeAll();
      } else {
        openSection(name);
      }
    });

    return {
      section: section,
      inner: inner
    };
  }

  function makeTab(name, text) {
    var button = el("button", "sparc-config-tab", text);
    button.type = "button";

    button.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      openSection(name);
    });

    tabs[name] = button;
    return button;
  }

  function closeAll() {
    Object.keys(accs).forEach(function (key) {
      if (accs[key].section) {
        accs[key].section.classList.remove("is-open");
      }
    });

    Object.keys(tabs).forEach(function (key) {
      tabs[key].classList.remove("is-active");
    });

    scheduleResize();
  }

  function openSection(name) {
    Object.keys(accs).forEach(function (key) {
      if (accs[key].section) {
        accs[key].section.classList.toggle("is-open", key === name);
      }
    });

    Object.keys(tabs).forEach(function (key) {
      tabs[key].classList.toggle("is-active", key === name);
    });

    scheduleResize();
  }

  function optionInfoCopy(sectionName, value) {
    var label = friendly(value);

    if (sectionName === "finish") {
      return "See a larger view of " + label +
        " and compare how this finish changes the appearance of the billet center and spokes.";
    }

    if (sectionName === "grip") {
      return "See a larger view of the " + label +
        " grip profile. Use the enlarged image to compare the hand position, " +
        "upper-grip geometry, and overall shape.";
    }

    if (sectionName === "leather") {
      return "See more detail for " + label +
        ". Leather and grip-finish selections affect both the appearance " +
        "and final feel of the steering wheel.";
    }

    if (sectionName === "horn") {
      return "See more detail for the " + label +
        " horn-button treatment and how it affects the finished center appearance.";
    }

    if (sectionName === "mounting") {
      return "See more information about " + label +
        " and how this mounting choice relates to steering-column fitment.";
    }

    if (sectionName === "accessories") {
      return "See more information about " + label +
        ", including fitment, finish, and how this optional accessory " +
        "works with your steering wheel package.";
    }

    return "More information about " + label + ".";
  }

  function sectionNameForRoot(root) {
    if (root === refs.finish) {
      return "finish";
    }

    if (root === refs.grip) {
      return "grip";
    }

    if (root === refs.leatherWrap || root === refs.leatherColor) {
      return "leather";
    }

    if (root === refs.hornLogo) {
      return "horn";
    }

    if (root === refs.adapter || root === refs.hubSleeve) {
      return "mounting";
    }

    if (
      root === refs.columnSpacer ||
      root === refs.columnSpacerFinish ||
      root === refs.careKit
    ) {
      return "accessories";
    }

    return "";
  }

  function addOptionInfoButton(container, root, value, imageUrl) {
    if (!container || !root) {
      return;
    }

    var sectionName = sectionNameForRoot(root);

    if (!sectionName) {
      return;
    }

    var button = el("button", "sparc-option-info", "i");
    button.type = "button";
    button.setAttribute(
      "aria-label",
      "More information about " + friendly(value)
    );

    button.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();

      openOptionInfoModal({
        section: sectionName,
        root: root,
        value: value,
        fallbackImage: imageUrl || "",
        detail: matchingOptionDetail(root.id, value)
      });
    });

    container.appendChild(button);
  }

  function setInfoModalGallery(modal, images, altText) {
    var main = q(".sparc-info-modal__image", modal);
    var strip = q(".sparc-info-modal__thumbs", modal);

    images = Array.isArray(images) ? images.filter(Boolean) : [];
    strip.innerHTML = "";

    if (!images.length) {
      main.removeAttribute("src");
      main.classList.remove("has-image");
      strip.classList.remove("has-images");
      return;
    }

    main.src = images[0];
    main.alt = altText || "";
    main.classList.add("has-image");

    if (images.length > 1) {
      strip.classList.add("has-images");

      images.forEach(function (url, index) {
        var button = el("button", "sparc-info-modal__thumb", "");
        button.type = "button";
        button.classList.toggle("is-active", index === 0);

        var image = document.createElement("img");
        image.src = url;
        image.alt = altText
          ? altText + " view " + (index + 1)
          : "Option detail view " + (index + 1);

        button.appendChild(image);

        button.addEventListener("click", function () {
          main.src = url;

          qa(".sparc-info-modal__thumb", strip).forEach(function (node) {
            node.classList.remove("is-active");
          });

          button.classList.add("is-active");
        });

        strip.appendChild(button);
      });
    } else {
      strip.classList.remove("has-images");
    }
  }

  function openOptionInfoModal(data) {
    var modal = ensureInfoModal();
    var sectionContent = INFO_CONTENT[data.section] || {};

    var detail = data.detail ||
      matchingOptionDetail(data.root && data.root.id, data.value);

    q(".sparc-info-modal__eyebrow", modal).textContent =
      sectionContent.eyebrow || "Option Information";

    q(".sparc-info-modal__title", modal).textContent =
      detail && detail.popupTitle
        ? detail.popupTitle
        : friendly(data.value);

    q(".sparc-info-modal__selection", modal).textContent =
      detail && detail.popupDescriptionHeading
        ? detail.popupDescriptionHeading
        : "OPTION DETAILS";

    var copy = q(".sparc-info-modal__copy", modal);

    if (detail && detail.popupDescriptionHtml) {
      copy.innerHTML = detail.popupDescriptionHtml;
    } else {
      copy.textContent = optionInfoCopy(data.section, data.value);
    }

    var images = popupImagesForOption(
      data.root,
      data.value,
      data.fallbackImage
    );

    setInfoModalGallery(
      modal,
      images,
      detail && detail.imageAltText
        ? detail.imageAltText
        : friendly(data.value)
    );

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("sparc-modal-open");
  }

  function cardGrid(root, columns, isGrip, placeholder) {
    var wrap = el(
      "div",
      "sparc-card-grid " +
      (columns === 3 ? "sparc-card-grid--3" : "sparc-card-grid--2")
    );

    choices(root).forEach(function (choice) {
      var detail = matchingOptionDetail(root.id, choice.value);
      var cardImage = selectorImageForOption(
        root,
        choice.value,
        choice.image
      );

      var button = el("button", "sparc-option-card");
      button.type = "button";
      button.dataset.value = choice.value;
      button.dataset.sourceId = root.id;
      button.disabled = !!choice.disabled;

      button.appendChild(el("span", "sparc-option-card__check", "✓"));
      addOptionInfoButton(button, root, choice.value, cardImage);

      var imageWrap = el(
        "div",
        "sparc-option-card__image" +
        (isGrip ? " sparc-option-card__image--grip" : "")
      );

      if (cardImage) {
        var image = document.createElement("img");
        image.src = cardImage;
        image.alt = detail && detail.imageAltText
          ? detail.imageAltText
          : friendly(choice.value);

        imageWrap.appendChild(image);
      } else {
        imageWrap.appendChild(
          el(
            "div",
            "sparc-option-card__placeholder",
            placeholder || "Add option image in Hulk Admin"
          )
        );
      }

      button.appendChild(imageWrap);

      var copy = el("div", "sparc-option-card__copy");

      copy.appendChild(
        el("span", "sparc-option-card__name", friendly(choice.value))
      );

      var meta = el("div", "sparc-option-card__meta");
      meta.appendChild(el("span", "sparc-option-card__note", ""));
      meta.appendChild(
        el("span", "sparc-option-card__price", choice.price || "")
      );

      copy.appendChild(meta);
      button.appendChild(copy);

      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        choose(root, choice.value);
      });

      wrap.appendChild(button);
    });

    return wrap;
  }

  function choiceGrid(root, metaMap) {
    var wrap = el("div", "sparc-choice-grid");

    choices(root).forEach(function (choice) {
      var metadata = (metaMap && metaMap[choice.value]) || {};
      var button = el("button", "sparc-choice");

      button.type = "button";
      button.dataset.value = choice.value;
      button.dataset.sourceId = root.id;
      button.disabled = !!choice.disabled;

      button.appendChild(
        el(
          "span",
          "sparc-choice__title",
          metadata.title || friendly(choice.value)
        )
      );

      button.appendChild(
        el(
          "span",
          "sparc-choice__sub",
          metadata.sub || choice.price || ""
        )
      );

      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        choose(root, choice.value);
      });

      wrap.appendChild(button);
    });

    return wrap;
  }

  function stitchGrid(root) {
    var wrap = el("div", "sparc-stitch-grid");
    var availableChoices = choices(root);
    var commonPrice = availableChoices.length && availableChoices[0].price;

    if (!availableChoices.every(function (choice) {
      return choice.price === commonPrice;
    })) {
      commonPrice = "";
    }

    availableChoices.forEach(function (choice) {
      var button = el("button", "sparc-stitch");
      button.type = "button";
      button.dataset.value = choice.value;
      button.dataset.sourceId = root.id;
      button.disabled = !!choice.disabled;

      var label = friendly(choice.value);
      var colorKey = Object.keys(STITCH_COLORS).find(function (name) {
        return name.toLowerCase() === label.toLowerCase();
      });

      var thread = el("span", "sparc-stitch__thread");
      thread.style.background = STITCH_COLORS[colorKey] || "#777";

      button.appendChild(thread);
      button.appendChild(el("span", "sparc-stitch__name", label));

      if (choice.price && !commonPrice) {
        button.appendChild(
          el("span", "sparc-stitch__price", choice.price)
        );
      }

      button.setAttribute(
        "aria-label",
        label + (choice.price ? ", " + choice.price : "")
      );

      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        choose(root, choice.value);
      });

      wrap.appendChild(button);
    });

    return wrap;
  }

  function conditional() {
    var outer = el("div", "sparc-conditional");
    outer.appendChild(el("div", "sparc-conditional__inner"));
    return outer;
  }

  function hideLegacyDecorations() {
    qa("*", document).forEach(function (node) {
      if (panel && panel.contains(node)) {
        return;
      }

      if (
        node.children.length <= 1 &&
        /^Choose Your Product Options:?$/i.test(clean(node.textContent))
      ) {
        node.classList.add("sparc-source-decoration-hidden");
      }

      if (
        node.children.length <= 3 &&
        /^Total price is\s*\$[\d,]+(?:\.\d{2})?$/i.test(clean(node.textContent))
      ) {
        node.classList.add("sparc-source-decoration-hidden");
      }
    });
  }

  function debugImageData() {
    var params = new URLSearchParams(window.location.search);

    if (params.get("sparc_debug") !== "1") {
      return;
    }

    var old = document.getElementById("sparc-image-debug");

    if (old) {
      old.remove();
    }

    var box = el("div", "");
    box.id = "sparc-image-debug";

    function rows(root, title) {
      var html = "<strong>" + title + "</strong>";
      var availableChoices = choices(root);
      var inputs = sourceInputs(root);

      availableChoices.forEach(function (choice) {
        var input = inputs.find(function (item) {
          return String(item.value) === String(choice.value);
        });

        var label = input ? labelForInput(input, root) : null;

        html +=
          "<code>" +
          choice.value.replace(/</g, "&lt;") +
          " -> " +
          (
            choice.image
              ? choice.image.replace(/</g, "&lt;")
              : "[NO EXACT IMAGE URL FOUND]"
          ) +
          "</code><br>";

        if (!choice.image && label) {
          var snippet = (label.outerHTML || "")
            .slice(0, 900)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;");

          html += "<code>label HTML: " + snippet + "</code><br>";
        }
      });

      return html;
    }

    box.innerHTML =
      "<b>SPARC V23 Exact Hulk Image Debug</b>" +
      rows(refs.finish, "Finish") +
      rows(refs.grip, "Grip") +
      rows(refs.leatherColor, "Leather Color");

    var mount = document.getElementById("sparc-muscle-configurator-mount");

    if (mount && mount.parentNode) {
      mount.parentNode.insertBefore(box, mount);
    }

    console.info("[SPARC Shared V42.7] Finish media", choices(refs.finish));
    console.info("[SPARC Shared V42.7] Grip media", choices(refs.grip));
    console.info(
      "[SPARC Shared V42.7] Leather Color media",
      choices(refs.leatherColor)
    );
  }

  function findCustomLaserFileSource() {
    var files = qa('input[type="file"]', document).filter(function (input) {
      return !input.classList.contains("sparc-custom-upload__input");
    });

    if (!files.length) {
      return null;
    }

    var candidates = files.map(function (input) {
      var score = 0;
      var parent = input.parentElement;
      var bestWrapper = input.parentElement;

      var descriptor = clean(
        (input.name || "") + " " +
        (input.id || "") + " " +
        (input.className || "") + " " +
        (input.getAttribute("data-name") || "") + " " +
        (input.getAttribute("data-label") || "")
      ).toLowerCase();

      if (/custom laser marking/.test(descriptor)) {
        score += 200;
      }

      if (/laser|marking/.test(descriptor)) {
        score += 90;
      }

      if (/custom|logo/.test(descriptor)) {
        score += 50;
      }

      for (
        var index = 0;
        index < 8 && parent && parent !== document.body;
        index++, parent = parent.parentElement
      ) {
        var text = clean(parent.textContent).toLowerCase();

        if (/custom laser marking/.test(text)) {
          score += 180;
        } else if (/laser.*mark|custom.*mark/.test(text)) {
          score += 100;
        } else if (/laser|marking|custom logo/.test(text)) {
          score += 35;
        }

        if (
          bestWrapper &&
          clean(parent.textContent).length &&
          clean(parent.textContent).length <
            clean(bestWrapper.textContent).length
        ) {
          bestWrapper = parent;
        }
      }

      return {
        input: input,
        wrapper: bestWrapper || input.parentElement,
        score: score
      };
    });

    candidates.sort(function (a, b) {
      return b.score - a.score;
    });

    return candidates[0] &&
      (candidates[0].score > 0 || files.length === 1)
        ? candidates[0]
        : null;
  }

  function customUploadBlock() {
    var outer = el("div", "sparc-custom-upload is-hidden");

    outer.appendChild(
      el("span", "sparc-custom-upload__label", "CUSTOM HORN LOGO ARTWORK")
    );

    outer.appendChild(
      el(
        "div",
        "sparc-custom-upload__help",
        "Upload the artwork file SPARC should use for your custom horn-button " +
        "laser marking. Vector artwork is preferred when available."
      )
    );

    var input = document.createElement("input");
    input.type = "file";
    input.className = "sparc-custom-upload__input";
    input.accept = ".ai,.eps,.svg,.pdf,.png,.jpg,.jpeg";

    var status = el(
      "div",
      "sparc-custom-upload__status",
      "No file selected"
    );

    outer.appendChild(input);
    outer.appendChild(status);

    outer._sparcProxyInput = input;
    outer._sparcStatus = status;
    outer._sparcProxyFile = null;
    outer._sparcFileInput = null;
    outer._sparcSourceWrapper = null;

    input.addEventListener("change", function () {
      outer._sparcProxyFile =
        input.files && input.files.length ? input.files[0] : null;

      status.classList.remove("is-ok", "is-error");

      if (!outer._sparcProxyFile) {
        status.textContent = "No file selected";

        if (sparcValidationAttempted) {
          applyValidationState();
        }

        return;
      }

      status.textContent = outer._sparcProxyFile.name;

      function finishStatus(ok) {
        status.classList.remove("is-ok", "is-error");

        if (ok) {
          status.classList.add("is-ok");
          status.textContent = outer._sparcProxyFile.name + " · ready";
        } else {
          status.textContent =
            outer._sparcProxyFile.name +
            " · connecting to product upload field…";
        }

        if (sparcValidationAttempted) {
          applyValidationState();
        }
      }

      var synced = syncProxyFileToHulk();
      finishStatus(synced);

      if (!synced) {
        setTimeout(function () {
          finishStatus(syncProxyFileToHulk());
        }, 150);

        setTimeout(function () {
          finishStatus(syncProxyFileToHulk());
        }, 500);

        setTimeout(function () {
          finishStatus(syncProxyFileToHulk());
        }, 1000);
      }
    });

    return outer;
  }

  function customFileVisualWrapper(input) {
    if (!input) {
      return null;
    }

    var fallback = input.parentElement;

    for (
      var parent = input.parentElement, index = 0;
      index < 8 && parent && parent !== document.body;
      index++, parent = parent.parentElement
    ) {
      if (/Custom Laser Marking/i.test(clean(parent.textContent))) {
        return parent;
      }

      if (parent.contains(input)) {
        fallback = parent;
      }
    }

    return fallback;
  }

  function setInputFiles(input, file) {
    if (!input || !file) {
      return false;
    }

    try {
      var transfer = new DataTransfer();
      transfer.items.add(file);
      input.files = transfer.files;

      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));

      return !!(
        input.files &&
        input.files.length &&
        input.files[0].name === file.name
      );
    } catch (error) {
      console.warn(
        "[SPARC Shared V42.7] Could not mirror file into Hulk input",
        error
      );

      return false;
    }
  }

  function syncProxyFileToHulk() {
    if (!accs.customLaserBlock) {
      return false;
    }

    var file = accs.customLaserBlock._sparcProxyFile;

    if (!file) {
      return false;
    }

    var source = findCustomLaserFileSource();

    if (!source || !source.input) {
      return false;
    }

    var input = source.input;
    var wrapper = customFileVisualWrapper(input);

    accs.customLaserBlock._sparcFileInput = input;
    accs.customLaserBlock._sparcSourceWrapper = wrapper;

    if (
      wrapper &&
      !panel.contains(wrapper) &&
      !wrapper.classList.contains("sparc-custom-file-source-hidden")
    ) {
      wrapper.classList.add("sparc-custom-file-source-hidden");
    }

    var ok = setInputFiles(input, file);
    var status = accs.customLaserBlock._sparcStatus;

    if (status) {
      status.classList.remove("is-ok", "is-error");

      if (ok) {
        status.classList.add("is-ok");
        status.textContent = file.name + " · ready";
      } else {
        status.classList.add("is-error");
        status.textContent = file.name + " · upload field not ready";
      }
    }

    return ok;
  }

  function connectCustomLaserUpload() {
    if (!accs.customLaserBlock) {
      return false;
    }

    var source = findCustomLaserFileSource();

    if (!source || !source.input) {
      return false;
    }

    var input = source.input;
    var wrapper = customFileVisualWrapper(input);

    accs.customLaserBlock._sparcFileInput = input;
    accs.customLaserBlock._sparcSourceWrapper = wrapper;

    if (
      wrapper &&
      !panel.contains(wrapper) &&
      !wrapper.classList.contains("sparc-custom-file-source-hidden")
    ) {
      wrapper.classList.add("sparc-custom-file-source-hidden");
    }

    if (accs.customLaserBlock._sparcProxyFile) {
      return syncProxyFileToHulk();
    }

    return true;
  }

  function isYesValue(value) {
    return /^yes\b/i.test(clean(value));
  }

  function visualMountingGrid(root, kind) {
    var grid = cardGrid(root, 2, false);

    if (kind === "adapter") {
      grid.classList.add("sparc-muscle-adapter-mount");
    } else if (kind === "sleeve") {
      grid.classList.add("sparc-muscle-hub-sleeve-mount");
    }

    return grid;
  }

  var INFO_CONTENT = {
    finish: {
      eyebrow: "01 · Finish",
      title: "Steering Wheel Finish",
      copy:
        "Choose the appearance of the billet center and spoke assembly. " +
        "The larger view helps compare the selected finish and the visual " +
        "character it gives the steering wheel."
    },
    grip: {
      eyebrow: "02 · Grip",
      title: "Grip Style",
      copy:
        "The grip profile changes the shape and feel of the steering wheel " +
        "in your hands. Compare the four available grip geometries in the " +
        "larger view before selecting the grip finish or leather treatment."
    },
    leather: {
      eyebrow: "03 · Grip Finish",
      title: "Leather & Grip Finish",
      copy:
        "Choose whether the grip will be leather wrapped or left in its raw " +
        "finish. Leather builds require leather color and stitching selections; " +
        "non-leather builds use the applicable raw-grip template."
    },
    horn: {
      eyebrow: "04 · Horn",
      title: "Horn Logo",
      copy:
        "Choose the horn-button marking treatment. Keep the standard SPARC " +
        "logo, delete the logo for a clean appearance, or choose Custom " +
        "and upload your own artwork."
    },
    mounting: {
      eyebrow: "05 · Mounting",
      title: "Mounting & Fitment",
      copy:
        "The adapter and hub-sleeve selections determine how the steering " +
        "wheel interfaces with your steering column. Confirm the steering-column " +
        "family carefully; aftermarket or retrofit columns may require " +
        "additional fitment verification."
    },
    accessories: {
      eyebrow: "06 · Accessories",
      title: "Optional Accessories",
      copy:
        "Add compatible installation and care accessories to your steering " +
        "wheel package. Column spacers are available in multiple depths and " +
        "finishes, while the shared Steering Wheel Care Kit can be added independently."
    },
    summary: {
      eyebrow: "Build Review",
      title: "Configuration Summary",
      copy:
        "Review the complete build before adding it to your cart. This summary " +
        "shows the currently selected finish, grip, leather or raw-grip choices, " +
        "horn treatment, mounting selections, and optional accessories."
    }
  };

  function ensureInfoModal() {
    var existing = document.getElementById("sparc-info-modal");

    if (existing) {
      return existing;
    }

    var modal = el("div", "");
    modal.id = "sparc-info-modal";
    modal.setAttribute("aria-hidden", "true");

    var backdrop = el("div", "sparc-info-modal__backdrop", "");
    modal.appendChild(backdrop);

    var dialog = el("div", "sparc-info-modal__dialog", "");
    dialog.setAttribute("role", "dialog");
    dialog.setAttribute("aria-modal", "true");

    var head = el("div", "sparc-info-modal__head", "");
    var titleWrap = el("div", "", "");

    titleWrap.appendChild(el("span", "sparc-info-modal__eyebrow", ""));
    titleWrap.appendChild(el("h2", "sparc-info-modal__title", ""));

    var close = el("button", "sparc-info-modal__close", "×");
    close.type = "button";
    close.setAttribute("aria-label", "Close information popup");

    head.appendChild(titleWrap);
    head.appendChild(close);
    dialog.appendChild(head);

    var body = el("div", "sparc-info-modal__body", "");
    var image = document.createElement("img");
    image.className = "sparc-info-modal__image";

    body.appendChild(image);
    body.appendChild(el("div", "sparc-info-modal__thumbs", ""));
    body.appendChild(el("div", "sparc-info-modal__selection", ""));
    body.appendChild(el("div", "sparc-info-modal__copy", ""));

    dialog.appendChild(body);
    modal.appendChild(dialog);
    document.body.appendChild(modal);

    function closeModal() {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("sparc-modal-open");
    }

    close.addEventListener("click", closeModal);
    backdrop.addEventListener("click", closeModal);

    document.addEventListener("keydown", function (event) {
      if (
        event.key === "Escape" &&
        modal.classList.contains("is-open")
      ) {
        closeModal();
      }
    });

    return modal;
  }

  function currentMuscleProductTitle() {
    var selectors = [
      "#ProductSection .product-single__title",
      ".product-single__title",
      '[itemprop="name"].product-single__title',
      'h1[itemprop="name"]'
    ];

    for (var index = 0; index < selectors.length; index++) {
      var node = document.querySelector(selectors[index]);

      if (node) {
        var title = clean(node.textContent || "");

        if (title) {
          return title;
        }
      }
    }

    var documentTitle = clean(document.title || "");

    if (documentTitle) {
      var parts = documentTitle.split(/\s+[–—|-]\s+/);

      if (parts[0]) {
        return clean(parts[0]);
      }
    }

    return "Steering Wheel";
  }

  function buildPanel() {
    var anchor = (sourceGroups.finish || [])[0];

    sourceHost = anchor && (
      anchor.closest(".hulkapps_option_set") ||
      anchor.parentElement
    );

    if (!sourceHost || !sourceHost.parentNode) {
      return false;
    }

    panel = el("section", "");
    panel.id = "sparc-muscle-configurator";

    var header = el("div", "sparc-build-header");
    var headerRow = el("div", "sparc-build-header__row");
    var titleWrap = el("div", "");

    titleWrap.appendChild(
      el("h2", "sparc-build-title", "Build Your " + currentMuscleProductTitle())
    );

    titleWrap.appendChild(
      el("div", "sparc-build-subtitle", "Configure your steering wheel.")
    );

    headerRow.appendChild(titleWrap);

    var metrics = el("div", "sparc-build-metrics");
    var priceMetric = el("div", "");

    priceMetric.appendChild(
      el("span", "sparc-metric-label", "CONFIGURED PRICE")
    );

    var priceValue = el("strong", "sparc-metric-value", "—");
    priceValue.id = "sparc-config-price";
    priceMetric.appendChild(priceValue);

    var leadMetric = el("div", "sparc-lead-metric");

    leadMetric.appendChild(
      el("span", "sparc-metric-label", "EST. PRODUCTION")
    );

    var leadValue = el("strong", "sparc-metric-value", "—");
    leadValue.id = "sparc-config-lead";
    leadMetric.appendChild(leadValue);

    metrics.appendChild(priceMetric);
    metrics.appendChild(leadMetric);
    headerRow.appendChild(metrics);
    header.appendChild(headerRow);

    var qualifierBar = el("div", "sparc-lead-qualifier-bar", "");
    qualifierBar.id = "sparc-config-lead-qualifier";
    qualifierBar.hidden = true;
    header.appendChild(qualifierBar);
    panel.appendChild(header);

    var tabRow = el("nav", "sparc-config-tabs");
    tabRow.appendChild(makeTab("finish", "FINISH"));
    tabRow.appendChild(makeTab("grip", "GRIP"));
    tabRow.appendChild(makeTab("leather", "LEATHER"));
    tabRow.appendChild(makeTab("horn", "HORN"));
    tabRow.appendChild(makeTab("mounting", "MOUNTING"));
    tabRow.appendChild(makeTab("accessories", "ACCESSORIES"));
    tabRow.appendChild(makeTab("summary", "SUMMARY"));
    panel.appendChild(tabRow);

    var list = el("div", "sparc-accordion-list");

    accs.finish = accordion("finish", "01", "STEERING WHEEL FINISH");

    accs.finish.inner.appendChild(
      el(
        "p",
        "sparc-section-help",
        "Choose the finish for the billet center and spoke assembly. " +
        "Compare the appearance of each finish and any price difference " +
        "before making your selection."
      )
    );

    sharedMounts.finish = el("div");
    accs.finish.inner.appendChild(sharedMounts.finish);
    list.appendChild(accs.finish.section);

    accs.grip = accordion("grip", "02", "GRIP STYLE");

    accs.grip.inner.appendChild(
      el(
        "p",
        "sparc-section-help",
        "Choose the grip profile and shape you prefer. Use the images to " +
        "compare the four available grip geometries before selecting the " +
        "grip finish or leather options."
      )
    );

    sharedMounts.grip = el("div");
    accs.grip.inner.appendChild(sharedMounts.grip);
    list.appendChild(accs.grip.section);

    accs.leather = accordion("leather", "03", "LEATHER & GRIP FINISH");

    accs.leather.inner.appendChild(
      el(
        "p",
        "sparc-section-help",
        "Choose how the grip will be finished. Select Leather Wrap to choose " +
        "leather color and stitching, or choose No Leather to keep the raw " +
        "grip finish and select the applicable grip template."
      )
    );

    sharedMounts.leatherWrap = el("div");
    accs.leather.inner.appendChild(sharedMounts.leatherWrap);

    accs.leatherColorBlock = conditional();

    var leatherColorInner = q(
      ".sparc-conditional__inner",
      accs.leatherColorBlock
    );

    leatherColorInner.appendChild(
      el("div", "sparc-subhead", "LEATHER COLOR")
    );

    accs.leatherColorChoices = el(
      "div",
      "sparc-card-grid sparc-card-grid--3 sparc-muscle-leather-color-mount"
    );

    leatherColorInner.appendChild(accs.leatherColorChoices);
    accs.leather.inner.appendChild(accs.leatherColorBlock);

    accs.stitchBlock = conditional();
    var stitchInner = q(".sparc-conditional__inner", accs.stitchBlock);

    stitchInner.appendChild(el("div", "sparc-subhead", "STITCHING COLOR"));

    accs.stitchChoices = el(
      "div",
      "sparc-stitch-grid sparc-muscle-stitch-mount"
    );

    accs.stitchPrice = el(
      "p",
      "sparc-section-help sparc-stitch-price",
      ""
    );

    accs.stitchPrice.hidden = true;
    stitchInner.appendChild(accs.stitchPrice);
    stitchInner.appendChild(accs.stitchChoices);
    accs.leather.inner.appendChild(accs.stitchBlock);

    accs.stitchNotice = el(
      "p",
      "sparc-section-help",
      "Stitching options are not available for this combination yet. Please contact SPARC."
    );

    accs.stitchNotice.hidden = true;
    accs.leather.inner.appendChild(accs.stitchNotice);

    accs.templateBlock = conditional();
    var templateInner = q(".sparc-conditional__inner", accs.templateBlock);

    templateInner.appendChild(el("div", "sparc-subhead", "RAW GRIP TEMPLATE"));

    accs.templateChoices = el(
      "div",
      "sparc-choice-grid sparc-muscle-template-mount"
    );

    templateInner.appendChild(accs.templateChoices);
    accs.leather.inner.appendChild(accs.templateBlock);
    list.appendChild(accs.leather.section);

    accs.horn = accordion("horn", "04", "HORN LOGO");

    accs.horn.inner.appendChild(
      el(
        "p",
        "sparc-section-help",
        "Choose the horn-button marking. Keep the standard SPARC logo, " +
        "remove the logo for a clean horn button, or choose Custom to " +
        "supply your own artwork."
      )
    );

    sharedMounts.hornLogo = el("div");
    accs.horn.inner.appendChild(sharedMounts.hornLogo);

    accs.hornNotice = el(
      "p",
      "sparc-section-help",
      "Select a steering wheel finish to see its horn-logo options."
    );

    accs.horn.inner.appendChild(accs.hornNotice);
    accs.customLaserBlock = customUploadBlock();
    accs.horn.inner.appendChild(accs.customLaserBlock);
    list.appendChild(accs.horn.section);

    accs.mounting = accordion("mounting", "05", "MOUNTING");

    accs.mounting.inner.appendChild(
      el(
        "p",
        "sparc-section-help",
        "Choose the steering-column adapter and whether to include a hub " +
        "sleeve. These are fitment choices; use the visual cards and the " +
        "information popup to compare the available mounting configurations."
      )
    );

    var adapterGroup = el("div", "sparc-mounting-group");
    adapterGroup.appendChild(el("div", "sparc-subhead", "COLUMN ADAPTER"));

    sharedMounts.adapter = el("div");
    adapterGroup.appendChild(sharedMounts.adapter);
    accs.mounting.inner.appendChild(adapterGroup);

    accs.hubSleeveBlock = conditional();
    var sleeveInner = q(".sparc-conditional__inner", accs.hubSleeveBlock);
    var sleeveGroup = el("div", "sparc-mounting-group");

    sleeveGroup.appendChild(el("div", "sparc-subhead", "HUB SLEEVE"));

    accs.hubSleeveChoices = el(
      "div",
      "sparc-card-grid sparc-card-grid--2 sparc-muscle-hub-sleeve-mount"
    );

    sleeveGroup.appendChild(accs.hubSleeveChoices);
    sleeveInner.appendChild(sleeveGroup);
    accs.mounting.inner.appendChild(accs.hubSleeveBlock);
    list.appendChild(accs.mounting.section);

    accs.accessories = accordion("accessories", "06", "ACCESSORIES");

    accs.accessories.inner.appendChild(
      el(
        "p",
        "sparc-section-help",
        "Add optional installation and care accessories to your steering " +
        "wheel package. Accessories are not required to complete the " +
        "steering wheel configuration."
      )
    );

    var spacerGroup = el("div", "sparc-accessory-group");
    spacerGroup.appendChild(el("div", "sparc-subhead", "COLUMN SPACER"));

    spacerGroup.appendChild(
      el(
        "p",
        "sparc-accessory-help",
        "Choose None if no spacer is needed, or select the spacer depth " +
        "that positions the steering wheel where you want it."
      )
    );

    accs.columnSpacerChoices = el(
      "div",
      "sparc-card-grid sparc-card-grid--3 sparc-column-spacer-choice-mount"
    );

    spacerGroup.appendChild(accs.columnSpacerChoices);
    accs.accessories.inner.appendChild(spacerGroup);

    accs.spacerFinishBlock = conditional();
    var spacerFinishInner = q(
      ".sparc-conditional__inner",
      accs.spacerFinishBlock
    );

    spacerFinishInner.appendChild(
      el("div", "sparc-subhead", "COLUMN SPACER FINISH")
    );

    spacerFinishInner.appendChild(
      el(
        "p",
        "sparc-accessory-help",
        'A spacer finish is required after selecting a 1" or 1.5" column spacer.'
      )
    );

    accs.spacerFinishChoices = el(
      "div",
      "sparc-card-grid sparc-card-grid--3 sparc-spacer-finish-choice-mount"
    );

    spacerFinishInner.appendChild(accs.spacerFinishChoices);
    accs.accessories.inner.appendChild(accs.spacerFinishBlock);

    var careGroup = el(
      "div",
      "sparc-accessory-group sparc-accessory-group--care"
    );

    careGroup.appendChild(el("div", "sparc-subhead", "CARE & MAINTENANCE"));
    accs.careKitChoices = el("div", "sparc-care-kit-choice-mount");
    careGroup.appendChild(accs.careKitChoices);
    accs.accessories.inner.appendChild(careGroup);
    list.appendChild(accs.accessories.section);

    accs.summary = accordion("summary", "✓", "CONFIGURATION SUMMARY");

    accs.summary.inner.appendChild(
      el(
        "p",
        "sparc-summary-intro",
        "Review every selected option, configured price, and fitment choice " +
        "before adding your steering wheel to the cart."
      )
    );

    var summary = el("div", "sparc-summary");

    [
      ["finish", "Steering Wheel Finish"],
      ["grip", "Grip Style"],
      ["leatherWrap", "Leather Wrap"],
      ["leatherColor", "Leather Color"],
      ["stitching", "Stitching"],
      ["leatherTemplate", "Raw Grip Template"],
      ["hornLogo", "Horn Logo"],
      ["adapter", "Adapter"],
      ["hubSleeve", "Hub Sleeve"],
      ["columnSpacer", "Column Spacer"],
      ["columnSpacerFinish", "Spacer Finish"],
      ["careKit", "Steering Wheel Care Kit"]
    ].forEach(function (pair) {
      var summaryRow = el("div", "sparc-summary-row");

      summaryRow.appendChild(
        el("div", "sparc-summary__label", pair[1])
      );

      summaryRow.appendChild(el("span", "sparc-summary__leader", ""));

      var value = el("div", "sparc-summary__value", "—");
      value.dataset.summaryKey = pair[0];

      summaryRow.appendChild(value);
      summary.appendChild(summaryRow);
    });

    accs.summary.inner.appendChild(summary);
    list.appendChild(accs.summary.section);
    panel.appendChild(list);

    var panelSlot = document.getElementById(
      "sparc-muscle-configurator-panel-slot"
    );

    var dedicatedMount = document.getElementById(
      "sparc-muscle-configurator-mount"
    );

    if (panelSlot) {
      panelSlot.appendChild(panel);
    } else if (dedicatedMount) {
      dedicatedMount.insertBefore(panel, dedicatedMount.firstChild);
    } else {
      sourceHost.parentNode.insertBefore(panel, sourceHost);
    }

    Object.keys(refs).forEach(function (key) {
      if (refs[key] && !panel.contains(refs[key])) {
        refs[key].classList.add("sparc-source-hidden");
      }
    });

    ensureMuscleConditionalUI();
    connectCustomLaserUpload();
    hideLegacyDecorations();
    openSection("finish");
    setTimeout(debugImageData, 250);

    return true;
  }

  function refreshVisualCardImages(root, section) {
    if (!root || !section) {
      return;
    }

    var latest = choices(root);

    qa(".sparc-option-card[data-value]", section).forEach(function (card) {
      if (card.dataset.sourceId !== root.id) {
        return;
      }

      var value = card.dataset.value;

      var choice = latest.find(function (item) {
        return String(item.value) === String(value);
      });

      if (!choice) {
        return;
      }

      var detail = matchingOptionDetail(root.id, value);
      var imageUrl = selectorImageForOption(root, value, choice.image);
      var imageWrap = q(".sparc-option-card__image", card);

      if (!imageWrap) {
        return;
      }

      var existingImage = q("img", imageWrap);
      var placeholder = q(".sparc-option-card__placeholder", imageWrap);

      if (imageUrl) {
        if (!existingImage) {
          existingImage = document.createElement("img");
          imageWrap.innerHTML = "";
          imageWrap.appendChild(existingImage);
        }

        existingImage.alt = detail && detail.imageAltText
          ? detail.imageAltText
          : friendly(value);

        if (existingImage.src !== imageUrl) {
          existingImage.src = imageUrl;
        }
      } else {
        if (existingImage) {
          imageWrap.innerHTML = "";
          placeholder = null;
        }

        if (!placeholder) {
          placeholder = el(
            "div",
            "sparc-option-card__placeholder",
            "Add option image in Hulk Admin"
          );

          imageWrap.appendChild(placeholder);
        }
      }
    });
  }

  function renderSourceMount(mount, root, key) {
    if (!mount) {
      return;
    }

    var availableChoices = choices(root);

    var signature = sourceToken(root) +
      JSON.stringify(availableChoices.map(function (choice) {
        return [
          choice.value,
          choice.price,
          choice.image,
          choice.disabled
        ];
      }));

    if (mount._sourceSignature === signature) {
      return;
    }

    mount._sourceSignature = signature;
    mount.replaceChildren();

    if (!root) {
      return;
    }

    var content;

    if (key === "stitching") {
      content = stitchGrid(root);
    } else if (key === "leatherWrap") {
      content = choiceGrid(root, {
        Yes: {
          title: "LEATHER WRAP",
          sub: "Leather color and stitching options appear below."
        },
        "None (raw finish)": {
          title: "NO LEATHER",
          sub: "Raw grip finish. Template option appears when applicable."
        }
      });
    } else if (key === "leatherTemplate") {
      content = choiceGrid(root, null);
    } else if (key === "adapter") {
      content = visualMountingGrid(root, "adapter");
    } else if (key === "hubSleeve") {
      content = visualMountingGrid(root, "sleeve");
    } else {
      content = cardGrid(
        root,
        key === "grip" || key === "hubSleeve" ? 2 : 3,
        key === "grip"
      );
    }

    if (!mount._layoutHooks) {
      mount._layoutHooks = Array.from(mount.classList).filter(function (name) {
        return /-mount$/.test(name);
      });
    }

    mount.className = content.className;

    mount._layoutHooks.forEach(function (name) {
      mount.classList.add(name);
    });

    moveChildren(content, mount);
    root.classList.add("sparc-source-hidden");
  }

  function extraSection(root) {
    return [
      "finish",
      "grip",
      "leather",
      "horn",
      "mounting",
      "accessories"
    ].find(function (key) {
      return root.classList.contains("sparc-section-" + key);
    }) || "extras";
  }

  function ensureExtraUI() {
    var roots = sourceRoots.filter(function (root) {
      var select = sourceSelect(root);

      return (
        !sourceRole(root) &&
        ((select && !select.multiple) || sourceInputs(root).length)
      );
    });

    if (roots.length && !accs.extras) {
      accs.extras = accordion("extras", "+", "ADDITIONAL OPTIONS");
      accs.summary.section.before(accs.extras.section);
      tabs.summary.before(makeTab("extras", "OPTIONS"));
    }

    extraFields.forEach(function (entry, root) {
      if (roots.indexOf(root) < 0) {
        entry.block.remove();
        entry.row.remove();
        extraFields.delete(root);
      }
    });

    roots.forEach(function (root) {
      var entry = extraFields.get(root);
      var section = extraSection(root);

      if (!entry) {
        var label = q(".hulkapps_option_name", root);

        var title = clean(
          label && (label.getAttribute("aria-label") || label.textContent)
        ).replace(/\s*\*\s*$/, " ").trim() || "Option";

        var block = el("div", "sparc-extra-option");
        block.appendChild(el("div", "sparc-subhead", title));

        var mount = el("div");
        block.appendChild(mount);
        accs[section].inner.appendChild(block);

        var row = el("div", "sparc-summary-row");
        row.appendChild(el("div", "sparc-summary__label", title));

        var value = el("div", "sparc-summary__value");
        row.appendChild(value);
        q(".sparc-summary", accs.summary.section).appendChild(row);

        entry = {
          block: block,
          mount: mount,
          row: row,
          value: value,
          section: section
        };

        extraFields.set(root, entry);
      }

      var visible = sourceVisible(root);
      entry.block.hidden = !visible;
      entry.row.hidden = !visible;

      renderSourceMount(entry.mount, visible ? root : null, "extra");
      syncChoiceClasses(root, entry.block);
      entry.value.textContent = current(root) ? friendly(current(root)) : "—";
    });
  }

  function ensureMuscleConditionalUI() {
    refreshRefs();

    sharedMounts.leatherColor = accs.leatherColorChoices;
    sharedMounts.stitching = accs.stitchChoices;
    sharedMounts.leatherTemplate = accs.templateChoices;
    sharedMounts.hubSleeve = accs.hubSleeveChoices;
    sharedMounts.columnSpacer = accs.columnSpacerChoices;
    sharedMounts.columnSpacerFinish = accs.spacerFinishChoices;
    sharedMounts.careKit = accs.careKitChoices;

    Object.keys(sharedMounts).forEach(function (key) {
      renderSourceMount(sharedMounts[key], refs[key], key);
    });

    sourceRoots.forEach(function (root) {
      if (sourceRole(root)) {
        root.classList.add("sparc-source-hidden");
      }
    });

    if (accs.hornNotice) {
      accs.hornNotice.hidden = !!refs.hornLogo;
      accs.hornNotice.textContent = current(refs.finish)
        ? "Horn-logo options are not available for this finish yet. Please contact SPARC."
        : "Select a steering wheel finish to see its horn-logo options.";
    }

    if (accs.summary) {
      ensureExtraUI();
    }

    [
      "finish",
      "grip",
      "leather",
      "horn",
      "mounting",
      "accessories",
      "extras"
    ].forEach(function (section) {
      if (!accs[section]) {
        return;
      }

      var visible = Object.keys(ROLE_SECTIONS).some(function (key) {
        return ROLE_SECTIONS[key] === section && !!refs[key];
      });

      if (section === "horn" && sourceGroups.hornLogo.length) {
        visible = true;
      }

      extraFields.forEach(function (entry, root) {
        if (entry.section === section && sourceVisible(root)) {
          visible = true;
        }
      });

      accs[section].section.hidden = !visible;

      if (tabs[section]) {
        tabs[section].hidden = !visible;
      }
    });
  }

  function syncChoiceClasses(root, section) {
    if (!root || !section) {
      return;
    }

    var values = sourceInputs(root).filter(function (input) {
      return input.checked;
    }).map(function (input) {
      return String(input.value);
    });

    if (sourceSelect(root)) {
      values = [String(current(root))];
    }

    qa("[data-source-id][data-value]", section).forEach(function (node) {
      if (node.dataset.sourceId !== root.id) {
        return;
      }

      node.classList.toggle(
        "is-selected",
        values.indexOf(String(node.dataset.value)) !== -1
      );
    });
  }

  function setConditional(block, show) {
    if (block) {
      block.classList.toggle("is-visible", !!show);
    }
  }

  function moveChildren(from, to) {
    while (from && from.firstChild) {
      to.appendChild(from.firstChild);
    }
  }

  function sync() {
    syncPending = false;

    if (!panel) {
      return;
    }

    refreshRefs();
    ensureMuscleConditionalUI();
    syncLaserMarkingTicket();
    syncStitchingTicket();
    syncBuildTickets();
    orderTicketFields();

    var state = getState();

    var leatherColorVisible = !!(
      refs.leatherColor && sourceVisible(refs.leatherColor)
    );

    var stitchingVisible = !!(
      refs.stitching && sourceVisible(refs.stitching)
    );

    var templateVisible = !!(
      refs.leatherTemplate && sourceVisible(refs.leatherTemplate)
    );

    if (accs.stitchPrice) {
      var stitchChoices = choices(refs.stitching);
      var commonStitchPrice = stitchChoices.length ? stitchChoices[0].price : "";

      if (!stitchChoices.every(function (choice) {
        return choice.price === commonStitchPrice;
      })) {
        commonStitchPrice = "";
      }

      var priceText = commonStitchPrice && commonStitchPrice !== "Included"
        ? "Leather wrap & stitching: " + commonStitchPrice
        : "";

      if (accs.stitchPrice.textContent !== priceText) {
        accs.stitchPrice.textContent = priceText;
      }

      accs.stitchPrice.hidden = !priceText;
    }

    if (accs.stitchNotice) {
      accs.stitchNotice.hidden = !(
        sourceGroups.stitching.length &&
        isYesValue(state.leatherWrap) &&
        state.leatherColor &&
        !refs.stitching
      );
    }

    var hubSleeveVisible = !!(
      refs.hubSleeve && sourceVisible(refs.hubSleeve)
    );

    var spacerFinishVisible = !!(
      refs.columnSpacerFinish && sourceVisible(refs.columnSpacerFinish)
    );

    syncChoiceClasses(refs.finish, accs.finish.section);
    syncChoiceClasses(refs.grip, accs.grip.section);
    syncChoiceClasses(refs.leatherWrap, accs.leather.section);
    syncChoiceClasses(refs.leatherColor, accs.leather.section);
    syncChoiceClasses(refs.stitching, accs.leather.section);
    syncChoiceClasses(refs.leatherTemplate, accs.leather.section);
    syncChoiceClasses(refs.hornLogo, accs.horn.section);
    syncChoiceClasses(refs.adapter, accs.mounting.section);
    syncChoiceClasses(refs.hubSleeve, accs.mounting.section);
    syncChoiceClasses(refs.columnSpacer, accs.accessories.section);
    syncChoiceClasses(refs.columnSpacerFinish, accs.accessories.section);
    syncChoiceClasses(refs.careKit, accs.accessories.section);

    refreshVisualCardImages(refs.finish, accs.finish.section);
    refreshVisualCardImages(refs.grip, accs.grip.section);

    if (refs.leatherColor) {
      refreshVisualCardImages(refs.leatherColor, accs.leather.section);
    }

    refreshVisualCardImages(refs.hornLogo, accs.horn.section);
    refreshVisualCardImages(refs.adapter, accs.mounting.section);

    if (refs.hubSleeve) {
      refreshVisualCardImages(refs.hubSleeve, accs.mounting.section);
    }

    if (refs.columnSpacer) {
      refreshVisualCardImages(refs.columnSpacer, accs.accessories.section);
    }

    if (refs.columnSpacerFinish) {
      refreshVisualCardImages(refs.columnSpacerFinish, accs.accessories.section);
    }

    if (refs.careKit) {
      refreshVisualCardImages(refs.careKit, accs.accessories.section);
    }

    setConditional(accs.leatherColorBlock, leatherColorVisible);
    setConditional(accs.stitchBlock, stitchingVisible);
    setConditional(accs.templateBlock, templateVisible);
    setConditional(accs.hubSleeveBlock, hubSleeveVisible);
    setConditional(accs.spacerFinishBlock, spacerFinishVisible);

    var customSource = findCustomLaserFileSource();
    var customSourceNode = customSource &&
      (customSource.input || customSource.wrapper);

    var customUploadVisible = !!(
      customSourceNode && sourceVisible(customSourceNode)
    );

    var customHornSelected = valueEquals(state.hornLogo, "Custom");

    if (accs.customLaserBlock) {
      accs.customLaserBlock.classList.toggle(
        "is-hidden",
        !customUploadVisible
      );

      accs.customLaserBlock.style.display = customUploadVisible ? "block" : "";
    }

    if (customHornSelected || customUploadVisible) {
      connectCustomLaserUpload();
      setTimeout(connectCustomLaserUpload, 120);
      setTimeout(connectCustomLaserUpload, 400);
      setTimeout(connectCustomLaserUpload, 900);
    }

    q("#sparc-config-price", panel).textContent = configuredPrice();
    q("#sparc-config-lead", panel).textContent = leadTime(state);

    var qualifierNode = q("#sparc-config-lead-qualifier", panel);

    if (qualifierNode) {
      var qualifier = leadQualifier(state);
      qualifierNode.textContent = qualifier;
      qualifierNode.hidden = !qualifier;
      qualifierNode.classList.toggle("is-visible", !!qualifier);
    }

    if (leadDebugEnabled()) {
      setTimeout(renderLeadDebug, 0);
    }

    q(".sparc-accordion__summary", accs.finish.section).textContent =
      friendly(state.finish);

    q(".sparc-accordion__summary", accs.grip.section).textContent =
      friendly(state.grip);

    var leatherParts = [];

    if (state.leatherWrap) {
      leatherParts.push(friendly(state.leatherWrap));
    }

    if (leatherColorVisible) {
      leatherParts.push(
        state.leatherColor
          ? friendly(state.leatherColor)
          : "Leather color required"
      );
    }

    if (stitchingVisible) {
      leatherParts.push(
        state.stitching
          ? friendly(state.stitching) + " Stitch"
          : "Stitching required"
      );
    }

    if (templateVisible) {
      leatherParts.push(
        state.leatherTemplate
          ? friendly(state.leatherTemplate)
          : "Template required"
      );
    }

    q(".sparc-accordion__summary", accs.leather.section).textContent =
      leatherParts.length ? leatherParts.join(" · ") : "Not selected";

    q(".sparc-accordion__summary", accs.horn.section).textContent =
      friendly(state.hornLogo);

    var mountingSummary = state.adapter
      ? friendly(state.adapter)
      : "Not selected";

    if (hubSleeveVisible && state.hubSleeve) {
      mountingSummary += " · Sleeve " + friendly(state.hubSleeve);
    }

    q(".sparc-accordion__summary", accs.mounting.section).textContent =
      mountingSummary;

    var accessoryParts = [];

    if (
      refs.columnSpacer &&
      sourceVisible(refs.columnSpacer) &&
      state.columnSpacer &&
      !valueEquals(state.columnSpacer, "None")
    ) {
      var spacerSummary = friendly(state.columnSpacer) + " Spacer";

      if (spacerFinishVisible) {
        spacerSummary += state.columnSpacerFinish
          ? " · " + friendly(state.columnSpacerFinish)
          : " · Finish required";
      }

      accessoryParts.push(spacerSummary);
    }

    if (
      refs.careKit &&
      sourceVisible(refs.careKit) &&
      valueEquals(state.careKit, "Yes")
    ) {
      accessoryParts.push("Care Kit");
    }

    q(".sparc-accordion__summary", accs.accessories.section).textContent =
      accessoryParts.length ? accessoryParts.join(" · ") : "None selected";

    qa("[data-summary-key]", accs.summary.section).forEach(function (node) {
      var key = node.dataset.summaryKey;
      var value = state[key];
      var row = node.closest(".sparc-summary-row");

      if (row) {
        row.hidden = !refs[key];
      }

      if (key === "leatherColor" && !leatherColorVisible) {
        value = "";
      }

      if (key === "stitching" && !stitchingVisible) {
        value = "";
      }

      if (key === "leatherTemplate" && !templateVisible) {
        value = "";
      }

      if (key === "hubSleeve" && !hubSleeveVisible) {
        value = "";
      }

      if (key === "columnSpacer" && (!value || valueEquals(value, "None"))) {
        value = "";
      }

      if (key === "columnSpacerFinish" && !spacerFinishVisible) {
        value = "";
      }

      if (key === "careKit") {
        value =
          refs.careKit &&
          sourceVisible(refs.careKit) &&
          valueEquals(value, "Yes")
            ? "Included"
            : "";
      }

      node.textContent = value ? friendly(value) : "—";
    });

    if (sparcValidationAttempted) {
      applyValidationState();
    }

    scheduleResize();
  }

  function queueSync() {
    if (syncPending) {
      return;
    }

    syncPending = true;
    requestAnimationFrame(sync);
  }

  function delayedSync() {
    queueSync();
    clearTimeout(syncTimer);

    syncTimer = setTimeout(function () {
      syncTimer = null;
      queueSync();

      if (panel) {
        var priceNode = q("#sparc-config-price", panel);

        if (priceNode) {
          priceNode.textContent = configuredPrice();
        }
      }
    }, 140);
  }

  function scheduleResize() {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
      var stage = q(".sparc-muscle-product-stage");
      var column = q(".sparc-muscle-options-column");

      if (!stage || !column || window.innerWidth <= 860) {
        return;
      }

      stage.style.minHeight =
        Math.max(800, column.scrollHeight + 60) + "px";
    }, 450);
  }

  function activateTrueMuscleWidth() {
    if (!panel) {
      return;
    }

    document.body.classList.add("sparc-muscle-v13-active");

    var main = document.getElementById("MainContent");

    if (!main || !main.parentElement) {
      return;
    }

    Array.prototype.forEach.call(main.parentElement.children, function (child) {
      if (child !== main) {
        child.classList.add("sparc-muscle-v13-sidebar-hidden");
      }
    });
  }

  function hideSmallestExactText(root, regex, className) {
    if (!root || !panel) {
      return;
    }

    var panelTop = panel.getBoundingClientRect().top;

    var matches = qa("*", root).filter(function (node) {
      if (
        panel.contains(node) ||
        node.classList.contains("sparc-source-hidden")
      ) {
        return false;
      }

      if (!regex.test(clean(node.textContent))) {
        return false;
      }

      return node.getBoundingClientRect().top < panelTop;
    });

    matches.sort(function (a, b) {
      var aLength = clean(a.textContent).length;
      var bLength = clean(b.textContent).length;

      return aLength !== bLength
        ? aLength - bLength
        : a.children.length - b.children.length;
    });

    if (matches.length) {
      matches[0].classList.add(className);
    }
  }

  function hideLegacyTopPriceAndLeadV13() {
    if (!panel) {
      return;
    }

    var meta =
      panel.closest(".sparc-muscle-product-meta") ||
      panel.closest(".product-single__meta") ||
      panel.parentElement;

    if (!meta) {
      return;
    }

    hideSmallestExactText(
      meta,
      /^\$[\d,]+(?:\.\d{2})?$/,
      "sparc-v13-old-price"
    );

    hideSmallestExactText(
      meta,
      /^Up to\s+\d+\s+week(?:s)?\s+lead\s+time$/i,
      "sparc-v13-old-lead"
    );
  }

  function moveQuantityBelowConfigurator() {
    if (!panel) {
      return;
    }

    var mount = document.getElementById("sparc-muscle-configurator-mount");

    var form =
      (mount && mount.closest("form")) ||
      panel.closest("form") ||
      q("form.product-form");

    if (!form) {
      return;
    }

    var realInput =
      q('input[name="quantity"]', form) ||
      q("#Quantity", form) ||
      q('input[name="quantity"]', document);

    if (!realInput) {
      return;
    }

    qa(".product-single__quantity", document).forEach(function (block) {
      if (block.contains(realInput) || q('input[name="quantity"]', block)) {
        block.classList.add("sparc-real-quantity-hidden");
      }
    });

    var host =
      document.getElementById("sparc-muscle-configurator-panel-slot") ||
      panel.parentElement;

    var mirror = q(".sparc-quantity-mirror", host);

    if (!mirror) {
      mirror = el("div", "sparc-quantity-mirror");

      var label = el("label", "sparc-quantity-mirror__label", "QUANTITY");
      var input = document.createElement("input");

      input.type = "number";
      input.min = realInput.min || "1";
      input.step = realInput.step || "1";
      input.value = realInput.value || "1";
      input.className = "sparc-quantity-mirror__input";

      mirror.appendChild(label);
      mirror.appendChild(input);
      host.insertBefore(mirror, panel.nextSibling);

      input.addEventListener("input", function () {
        realInput.value = input.value;
        realInput.dispatchEvent(new Event("input", { bubbles: true }));
        realInput.dispatchEvent(new Event("change", { bubbles: true }));
      });

      input.addEventListener("change", function () {
        realInput.value = input.value;
        realInput.dispatchEvent(new Event("change", { bubbles: true }));
      });

      realInput.addEventListener("change", function () {
        if (input.value !== realInput.value) {
          input.value = realInput.value;
        }
      });
    }

    var mirrorInput = q(".sparc-quantity-mirror__input", mirror);

    if (mirrorInput && mirrorInput.value !== realInput.value) {
      mirrorInput.value = realInput.value || "1";
    }

    if (panel.nextSibling !== mirror) {
      host.insertBefore(mirror, panel.nextSibling);
    }
  }

  function hideOldProductPriceAndLeadTime() {
    if (!panel) {
      return;
    }

    var meta = panel.closest(".sparc-muscle-product-meta") || panel.parentElement;

    if (!meta) {
      return;
    }

    var panelTop = panel.getBoundingClientRect().top;

    qa("*", meta).forEach(function (node) {
      if (
        panel.contains(node) ||
        node.classList.contains("sparc-source-hidden")
      ) {
        return;
      }

      var text = clean(node.textContent);

      if (!text || node.getBoundingClientRect().top >= panelTop) {
        return;
      }

      if (
        node.children.length === 0 &&
        /^\$[\d,]+(?:\.\d{2})?$/.test(text)
      ) {
        node.classList.add("sparc-old-product-price-hidden");
      }

      if (
        node.children.length === 0 &&
        /^(?:up to\s+)?\d+\s*(?:-|–|to)?\s*\d*\s*week(?:s)?(?:\s+lead\s+time)?$/i.test(text)
      ) {
        node.classList.add("sparc-old-lead-time-hidden");
      }
    });

    qa("p,div,span", meta).forEach(function (node) {
      if (panel.contains(node) || node.children.length > 1) {
        return;
      }

      if (node.getBoundingClientRect().top >= panelTop) {
        return;
      }

      if (/^Up to \d+\s*week(?:s)? lead time$/i.test(clean(node.textContent))) {
        node.classList.add("sparc-old-lead-time-hidden");
      }
    });
  }

  function applyV11Polish() {
    if (document.querySelector(
      '.sparc-series-muscle,[id^="sparc-muscle-finish"]'
    )) {
      activateTrueMuscleWidth();
    }

    moveQuantityBelowConfigurator();
    hideOldProductPriceAndLeadTime();
    hideLegacyTopPriceAndLeadV13();
  }

  var sparcValidationAttempted = false;

  function hasUploadedCustomFile() {
    if (!accs.customLaserBlock) {
      return false;
    }

    if (accs.customLaserBlock._sparcProxyFile) {
      return syncProxyFileToHulk();
    }

    var source = findCustomLaserFileSource();

    var input =
      accs.customLaserBlock._sparcFileInput ||
      (source && source.input);

    return !!(input && input.files && input.files.length > 0);
  }

  function sectionValidity(state) {
    var leatherOK =
      !stitchTicketError &&
      (!refs.leatherWrap || !!state.leatherWrap);

    if (sourceGroups.stitching.length && isYesValue(state.leatherWrap)) {
      leatherOK = leatherOK && !!refs.stitching && !!state.stitching;
    }

    if (refs.leatherColor && sourceVisible(refs.leatherColor)) {
      leatherOK = leatherOK && !!state.leatherColor;
    }

    if (refs.stitching && sourceVisible(refs.stitching)) {
      leatherOK = leatherOK && !!state.stitching;
    }

    if (refs.leatherTemplate && sourceVisible(refs.leatherTemplate)) {
      leatherOK = leatherOK && !!state.leatherTemplate;
    }

    var customSource = findCustomLaserFileSource();
    var customSourceNode = customSource &&
      (customSource.input || customSource.wrapper);

    var customUploadVisible = !!(
      customSourceNode && sourceVisible(customSourceNode)
    );

    var hornOK =
      !ticketBridgeError &&
      (!sourceGroups.hornLogo.length || !!state.hornLogo) &&
      (!customUploadVisible || hasUploadedCustomFile());

    var mountingOK = !refs.adapter || !!state.adapter;

    if (refs.hubSleeve && sourceVisible(refs.hubSleeve)) {
      mountingOK = mountingOK && !!state.hubSleeve;
    }

    var accessoriesOK = true;

    if (refs.columnSpacerFinish && sourceVisible(refs.columnSpacerFinish)) {
      accessoriesOK = !!state.columnSpacerFinish;
    }

    var result = {
      finish: !refs.finish || !!state.finish,
      grip: !refs.grip || !!state.grip,
      leather: leatherOK,
      horn: hornOK,
      mounting: mountingOK,
      accessories: accessoriesOK,
      extras: true
    };

    extraFields.forEach(function (entry, root) {
      var required =
        root.classList.contains("required") ||
        !!q("[required],[aria-required='true']", root);

      if (required && sourceVisible(root) && !current(root)) {
        result[entry.section] = false;
      }
    });

    Object.keys(sourceGroups).forEach(function (key) {
      if (sourceGroups[key].filter(sourceVisible).length > 1) {
        result[ROLE_SECTIONS[key]] = false;
      }
    });

    Object.keys(buildTicketErrors).forEach(function (role) {
      result[ROLE_SECTIONS[role]] = false;
    });

    return result;
  }

  function applyValidationState() {
    if (!panel) {
      return true;
    }

    var validity = sectionValidity(getState());
    var anyInvalid = false;

    [
      "finish",
      "grip",
      "leather",
      "horn",
      "mounting",
      "accessories",
      "extras"
    ].forEach(function (name) {
      var invalid = !validity[name];

      if (accs[name] && accs[name].section) {
        accs[name].section.classList.toggle("sparc-invalid", invalid);
      }

      if (invalid) {
        anyInvalid = true;
      }
    });

    panel.classList.toggle("sparc-has-invalid", anyInvalid);
    return !anyInvalid;
  }

  function showValidationWarnings() {
    refreshRefs();
    syncLaserMarkingTicket();
    syncStitchingTicket();
    syncBuildTickets();
    orderTicketFields();

    var message = q(".sparc-validation-message", panel);

    if (message) {
      if (ticketBridgeError) {
        message.textContent =
          "This horn cap configuration is temporarily unavailable. " +
          "Please contact us for help with your selection.";
      } else if (stitchTicketError) {
        message.textContent =
          "This leather configuration is temporarily unavailable. " +
          "Please contact us for help with your selection.";
      } else if (Object.keys(buildTicketErrors).length) {
        message.textContent =
          "This configuration is temporarily unavailable. " +
          "Please contact us for help with your selection.";
      } else {
        message.textContent =
          "Please complete the required configuration options highlighted " +
          "below before adding this steering wheel to your cart.";
      }
    }

    sparcValidationAttempted = true;
    panel.classList.add("sparc-validation-attempted");

    var valid = applyValidationState();

    if (!valid) {
      var validity = sectionValidity(getState());

      var firstInvalid = [
        "finish",
        "grip",
        "leather",
        "horn",
        "mounting",
        "accessories",
        "extras"
      ].find(function (name) {
        return !validity[name];
      });

      if (firstInvalid) {
        openSection(firstInvalid);

        setTimeout(function () {
          if (accs[firstInvalid] && accs[firstInvalid].section) {
            accs[firstInvalid].section.scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          }
        }, 80);
      }
    }

    return valid;
  }

  function isAddToCartControl(node) {
    if (!node) {
      return false;
    }

    var control = node.closest('button,input[type="submit"],a');

    if (!control) {
      return false;
    }

    var text = clean(
      (control.textContent || "") + " " +
      (control.value || "") + " " +
      (control.getAttribute("aria-label") || "")
    ).toLowerCase();

    return /add\s+to\s+cart/.test(text);
  }

  function installRequiredValidation() {
    if (!panel) {
      return;
    }

    var list = q(".sparc-accordion-list", panel);

    if (list && !q(".sparc-validation-message", panel)) {
      var message = el(
        "div",
        "sparc-validation-message",
        "Please complete the required configuration options highlighted " +
        "below before adding this steering wheel to your cart."
      );

      list.insertBefore(message, list.firstChild);
    }

    document.addEventListener("click", function (event) {
      if (!isAddToCartControl(event.target)) {
        return;
      }

      var control = event.target.closest('button,input[type="submit"],a');

      var productArea =
        q(".sparc-muscle-options-column", document) ||
        q("#ProductSection", document);

      if (productArea && !productArea.contains(control)) {
        return;
      }

      if (!showValidationWarnings()) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    }, true);

    var form = productOptionForm();

    if (form) {
      form.addEventListener("submit", function (event) {
        if (!showValidationWarnings()) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
        }
      }, true);
    }
  }

  function ensureRuntimeBreadcrumbStyle() {
    if (document.getElementById("sparc-muscle-runtime-breadcrumb-style")) {
      return;
    }

    var style = document.createElement("style");
    style.id = "sparc-muscle-runtime-breadcrumb-style";

    style.textContent = [
      "#sparc-muscle-runtime-breadcrumb-wrap{",
      "display:block!important;",
      "box-sizing:border-box!important;",
      "width:100%!important;",
      "height:auto!important;",
      "min-height:28px!important;",
      "margin:0 0 18px!important;",
      "padding:0!important;",
      "overflow:visible!important;",
      "}",
      "#sparc-muscle-runtime-breadcrumb{",
      "display:flex!important;",
      "align-items:center!important;",
      "gap:7px!important;",
      "height:auto!important;",
      "min-height:22px!important;",
      "margin:0!important;",
      "padding:3px 0 4px!important;",
      "line-height:17px!important;",
      "overflow:visible!important;",
      "font:inherit!important;",
      "font-size:11px!important;",
      "white-space:nowrap!important;",
      "}",
      "#sparc-muscle-runtime-breadcrumb a,",
      "#sparc-muscle-runtime-breadcrumb span{",
      "display:inline-block!important;",
      "position:static!important;",
      "height:auto!important;",
      "min-height:17px!important;",
      "margin:0!important;",
      "padding:1px 0!important;",
      "line-height:17px!important;",
      "overflow:visible!important;",
      "vertical-align:middle!important;",
      "text-decoration:none;",
      "}",
      "#sparc-muscle-runtime-breadcrumb .sparc-muscle-runtime-breadcrumb__sep{",
      "opacity:.7;",
      "}"
    ].join("");

    document.head.appendChild(style);
  }

  function normalizeRenderedBreadcrumbText(value) {
    return String(value || "")
      .replace(/[›>»\/|·•]/g, " ")
      .replace(/[^a-zA-Z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }

  function hideRenderedLegacyBreadcrumb(runtimeWrap, productTitle) {
    if (!runtimeWrap) {
      return;
    }

    var runtimeRect = runtimeWrap.getBoundingClientRect();
    var target = normalizeRenderedBreadcrumbText(
      "Home Muscle Series " + productTitle
    );

    if (!target) {
      return;
    }

    var exact = [];
    var fallback = [];

    qa("*", document.body).forEach(function (node) {
      if (
        node === runtimeWrap ||
        runtimeWrap.contains(node) ||
        node.contains(runtimeWrap)
      ) {
        return;
      }

      var rect = node.getBoundingClientRect();

      if (
        rect.width <= 0 ||
        rect.height <= 0 ||
        rect.left < 0 ||
        rect.left > 700 ||
        rect.top < 35 ||
        rect.top >= runtimeRect.top - 2 ||
        rect.width > 850 ||
        rect.height > 100
      ) {
        return;
      }

      var visible = "";

      try {
        visible = node.innerText || "";
      } catch (error) {
        visible = node.textContent || "";
      }

      var normalized = normalizeRenderedBreadcrumbText(visible);

      if (!normalized) {
        return;
      }

      var record = {
        node: node,
        rect: rect,
        norm: normalized,
        area: rect.width * rect.height
      };

      if (normalized === target) {
        exact.push(record);
        return;
      }

      if (
        normalized.indexOf("home") !== -1 &&
        normalized.indexOf("muscle series") !== -1 &&
        normalized.indexOf(normalizeRenderedBreadcrumbText(productTitle)) !== -1 &&
        normalized.length <= target.length + 24
      ) {
        fallback.push(record);
      }
    });

    var matches = exact.length ? exact : fallback;

    if (!matches.length) {
      return;
    }

    matches.sort(function (a, b) {
      return a.area !== b.area
        ? a.area - b.area
        : b.rect.top - a.rect.top;
    });

    var legacy = matches[0].node;
    legacy.style.setProperty("display", "none", "important");
    legacy.setAttribute("data-sparc-legacy-breadcrumb-hidden", "true");
  }

  function hideLegacyBreadcrumbByLinks(runtimeWrap, productTitle) {
    if (!runtimeWrap) {
      return;
    }

    var runtimeRect = runtimeWrap.getBoundingClientRect();
    var titleNormalized = clean(productTitle).toLowerCase();

    function visible(node) {
      if (!node) {
        return false;
      }

      var rect = node.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }

    function isRuntime(node) {
      return (
        node === runtimeWrap ||
        runtimeWrap.contains(node) ||
        node.contains(runtimeWrap)
      );
    }

    qa("a", document).forEach(function (home) {
      if (
        isRuntime(home) ||
        clean(home.textContent).toLowerCase() !== "home" ||
        !visible(home)
      ) {
        return;
      }

      var homeRect = home.getBoundingClientRect();

      if (
        homeRect.left > 700 ||
        homeRect.top < 30 ||
        homeRect.top > runtimeRect.bottom + 25
      ) {
        return;
      }

      var line = null;

      for (
        var parent = home.parentElement, index = 0;
        index < 8 && parent && parent !== document.body && !isRuntime(parent);
        index++, parent = parent.parentElement
      ) {
        var links = qa("a", parent);

        var hasHome = links.some(function (link) {
          return clean(link.textContent).toLowerCase() === "home";
        });

        var hasSeries = links.some(function (link) {
          return clean(link.textContent).toLowerCase().indexOf("muscle series") !== -1;
        });

        if (hasHome && hasSeries) {
          line = parent;
          break;
        }
      }

      if (line && !isRuntime(line)) {
        line.style.setProperty("display", "none", "important");
        line.setAttribute("data-sparc-legacy-breadcrumb-hidden", "home-series");
      } else {
        home.style.setProperty("display", "none", "important");
      }
    });

    qa("a", document).forEach(function (series) {
      if (
        isRuntime(series) ||
        clean(series.textContent).toLowerCase().indexOf("muscle series") === -1 ||
        !visible(series)
      ) {
        return;
      }

      var seriesRect = series.getBoundingClientRect();

      if (
        seriesRect.left > 700 ||
        seriesRect.top < 30 ||
        seriesRect.top > runtimeRect.bottom + 35
      ) {
        return;
      }

      var fragment = null;

      for (
        var parent = series.parentElement, index = 0;
        index < 6 && parent && parent !== document.body && !isRuntime(parent);
        index++, parent = parent.parentElement
      ) {
        var text = clean(parent.textContent).toLowerCase();
        var rect = parent.getBoundingClientRect();

        var hasProduct =
          titleNormalized && text.indexOf(titleNormalized) !== -1;

        var hasHome = text.indexOf("home") !== -1;

        if (
          hasProduct &&
          !hasHome &&
          rect.width > 0 &&
          rect.width < 700 &&
          rect.height > 0 &&
          rect.height < 80
        ) {
          fragment = parent;
          break;
        }
      }

      if (fragment && !isRuntime(fragment)) {
        fragment.style.setProperty("display", "none", "important");
        fragment.setAttribute(
          "data-sparc-legacy-breadcrumb-hidden",
          "series-product"
        );
      }
    });
  }

  function replaceMuscleBreadcrumb() {
    if (!document.querySelector(
      '.sparc-series-muscle,[id^="sparc-muscle-finish"]'
    )) {
      return;
    }

    ensureRuntimeBreadcrumbStyle();

    if (document.getElementById("sparc-muscle-runtime-breadcrumb-wrap")) {
      return;
    }

    var productTitle = currentMuscleProductTitle();

    if (!productTitle) {
      var title =
        q(".product-single__title") ||
        q("#ProductSection .product-single__title");

      productTitle = title ? clean(title.textContent) : "";
    }

    var homeLinks = qa("a", document).filter(function (link) {
      return clean(link.textContent).toLowerCase() === "home";
    });

    var homeLink = null;
    var seriesLink = null;
    var originalBreadcrumb = null;

    homeLinks.some(function (home) {
      if (home.closest("#sparc-muscle-runtime-breadcrumb-wrap")) {
        return false;
      }

      for (
        var parent = home.parentElement, index = 0;
        index < 6 && parent && parent !== document.body;
        index++, parent = parent.parentElement
      ) {
        var text = clean(parent.textContent);
        var rect = parent.getBoundingClientRect();
        var hasHome = text.toLowerCase().indexOf("home") === 0;
        var hasSeries = text.toLowerCase().indexOf("muscle series") !== -1;

        var compact =
          rect.top >= 40 &&
          rect.top < 260 &&
          rect.left < 700 &&
          rect.width > 0 &&
          rect.width < 800 &&
          rect.height > 0 &&
          rect.height < 90 &&
          text.length < 200;

        if (hasHome && hasSeries && compact) {
          homeLink = home;
          originalBreadcrumb = parent;

          seriesLink = qa("a", parent).find(function (link) {
            return clean(link.textContent)
              .toLowerCase()
              .indexOf("muscle series") !== -1;
          }) || null;

          return true;
        }
      }

      return false;
    });

    var productSection =
      document.getElementById("ProductSection") ||
      q(".product-single") ||
      q("main");

    if (!productSection) {
      return;
    }

    var insertionTarget = productSection;
    var parent = productSection.parentElement;

    while (
      parent &&
      parent !== document.body &&
      parent.children.length === 1 &&
      parent.getBoundingClientRect().width < 1200
    ) {
      insertionTarget = parent;
      parent = parent.parentElement;
    }

    var wrap = el("div", "sparc-muscle-runtime-breadcrumb-wrap");
    wrap.id = "sparc-muscle-runtime-breadcrumb-wrap";

    var crumb = el("nav", "sparc-muscle-runtime-breadcrumb");
    crumb.id = "sparc-muscle-runtime-breadcrumb";
    crumb.setAttribute("aria-label", "Breadcrumb");

    function addLink(source, fallbackText, fallbackHref) {
      var href = source && source.getAttribute("href")
        ? source.getAttribute("href")
        : fallbackHref;

      if (href) {
        var link = document.createElement("a");
        link.href = href;
        link.textContent = source && clean(source.textContent)
          ? clean(source.textContent)
          : fallbackText;

        crumb.appendChild(link);
      } else {
        crumb.appendChild(el("span", "", fallbackText));
      }
    }

    function separator() {
      crumb.appendChild(
        el("span", "sparc-muscle-runtime-breadcrumb__sep", "›")
      );
    }

    addLink(homeLink, "Home", "/");
    separator();
    addLink(seriesLink, "Muscle Series", "/collections/muscle-series");

    if (productTitle) {
      separator();

      var currentProduct = el(
        "span",
        "sparc-muscle-runtime-breadcrumb__current",
        productTitle
      );

      currentProduct.setAttribute("aria-current", "page");
      crumb.appendChild(currentProduct);
    }

    wrap.appendChild(crumb);
    insertionTarget.parentNode.insertBefore(wrap, insertionTarget);

    if (originalBreadcrumb && !originalBreadcrumb.contains(wrap)) {
      originalBreadcrumb.style.setProperty("display", "none", "important");
    }

    function cleanupLegacyFragments() {
      var titleNormalized = clean(productTitle).toLowerCase();

      qa("*", document).forEach(function (node) {
        if (
          node === wrap ||
          node === crumb ||
          wrap.contains(node) ||
          node.contains(wrap)
        ) {
          return;
        }

        var rect = node.getBoundingClientRect();

        if (
          rect.top < 40 ||
          rect.top > 260 ||
          rect.left < 20 ||
          rect.left > 700 ||
          rect.width <= 0 ||
          rect.width > 800 ||
          rect.height <= 0 ||
          rect.height > 90
        ) {
          return;
        }

        var text = clean(node.textContent).toLowerCase();
        var hasHome = text.indexOf("home") !== -1;
        var hasSeries = text.indexOf("muscle series") !== -1;
        var hasTitle = titleNormalized && text.indexOf(titleNormalized) !== -1;

        if ((hasHome && hasSeries) || (hasSeries && hasTitle)) {
          if (qa("img", node).length || qa("#ProductSection", node).length) {
            return;
          }

          node.style.setProperty("display", "none", "important");
        }
      });
    }

    cleanupLegacyFragments();
    hideRenderedLegacyBreadcrumb(wrap, productTitle);
    hideLegacyBreadcrumbByLinks(wrap, productTitle);

    [80, 220, 500, 1000].forEach(function (delay) {
      setTimeout(function () {
        cleanupLegacyFragments();
        hideRenderedLegacyBreadcrumb(wrap, productTitle);
        hideLegacyBreadcrumbByLinks(wrap, productTitle);
      }, delay);
    });
  }

  /*
   * Only actual series-defining fields identify a dedicated configurator.
   * Muscle legitimately uses sparc-heritage-custom-laser-marking.
   * Shared uploads, adapters and other accessories must not exclude Muscle.
   */
  function dedicatedSeriesOwnsPage() {
    var path = String(window.location.pathname || "").toLowerCase();

    if (/\/collections\/(?:driver|garage|heritage)-series\/products\//.test(path)) {
      return true;
    }

    var product = window.hulkapps && window.hulkapps.product;
    var tags = product && product.tags;

    if (typeof tags === "string") {
      tags = tags.split(",");
    }

    if (
      Array.isArray(tags) &&
      tags.some(function (tag) {
        var normalized = String(tag)
          .trim()
          .toLowerCase()
          .replace(/[-_]+/g, " ")
          .replace(/\s+/g, " ");

        return /^(?:driver|garage|heritage)(?: series)?$/.test(normalized);
      })
    ) {
      return true;
    }

    var dedicatedSelectors = [
      "#sparc-driver-configurator",
      "#sparc-garage-configurator",
      "#sparc-heritage-configurator",
      "#sparc-driver-finish",
      "#sparc-garage-finish",
      "#sparc-heritage-horn-ring-finish",
      "#sparc-heritage-finish"
    ];

    if (document.querySelector(dedicatedSelectors.join(","))) {
      return true;
    }

    return (sourceRoots || []).some(function (root) {
      var id = root.id || "";

      return (
        /^sparc-(?:driver|garage)-finish(?:$|-)/.test(id) ||
        /^sparc-heritage-(?:horn-ring-finish|finish)(?:$|-)/.test(id)
      );
    });
  }

  function start() {
    if (
      dedicatedSeriesOwnsPage() ||
      document.getElementById("sparc-muscle-configurator")
    ) {
      return;
    }

    var missing = allRefsPresent();

    /*
     * Recheck after discovering Hulk fields, because Hulk may load them
     * asynchronously after the first page check.
     */
    if (dedicatedSeriesOwnsPage()) {
      return;
    }

    if (missing.length) {
      setTimeout(start, 500);
      return;
    }

    if (!buildPanel()) {
      return;
    }

    refreshRefs();

    if (window.console && console.info) {
      var accessoryMissing = [
        ["columnSpacer", IDS.columnSpacer],
        ["columnSpacerFinish", IDS.columnSpacerFinish],
        ["careKit", IDS.careKit]
      ].filter(function (pair) {
        return pair[0] !== "columnSpacerFinish" && !refs[pair[0]];
      }).map(function (pair) {
        return pair[1];
      });

      if (accessoryMissing.length) {
        console.info(
          "[SPARC Shared V42.7] Configurator started. " +
          "Accessory selectors not currently found:",
          accessoryMissing
        );
      }
    }

    setTimeout(delayedSync, 120);
    applyV11Polish();
    replaceMuscleBreadcrumb();
    setTimeout(replaceMuscleBreadcrumb, 120);
    installRequiredValidation();

    var observer = new MutationObserver(function (records) {
      var relevant = records.some(function (record) {
        if (panel && panel.contains(record.target)) {
          return false;
        }

        if (record.type === "attributes" && record.attributeName === "class") {
          function externalClasses(value) {
            return String(value || "")
              .split(/\s+/)
              .filter(function (className) {
                return className && !/^sparc-/.test(className);
              })
              .sort()
              .join(" ");
          }

          if (
            externalClasses(record.oldValue) ===
            externalClasses(record.target.className)
          ) {
            return false;
          }
        }

        return true;
      });

      if (relevant) {
        delayedSync();
      }
    });

    observer.observe(sourceHost.parentElement || sourceHost, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeOldValue: true,
      attributeFilter: [
        "class",
        "style",
        "hidden",
        "disabled",
        "aria-hidden",
        "value",
        "data-price",
        "data-variant-id"
      ]
    });

    var eventHost = sourceHost.parentElement || sourceHost;
    eventHost.addEventListener("change", delayedSync, true);
    eventHost.addEventListener("input", delayedSync, true);
    window.addEventListener("resize", scheduleResize);

    var detailData = optionDetailData();

    if (detailData && Array.isArray(detailData.entries)) {
      console.info(
        "[SPARC Shared V42.7] Shopify option-detail entries loaded:",
        detailData.entries
      );
    }

    var leadData = leadTimeData();

    if (leadData && Array.isArray(leadData.rules)) {
      console.info("[SPARC Shared V42.7] Lead-time bridge loaded:", {
        bridgeVersion: leadData.bridgeVersion,
        ruleCount: leadData.ruleCount,
        productHandle: leadData.productHandle,
        seriesScope: leadData.seriesScope,
        rules: leadData.rules
      });

      leadData.rules.forEach(function (rule) {
        if (!validLeadRule(rule)) {
          console.warn(
            "[SPARC Shared V42.7] Invalid lead-time rule ignored:",
            rule
          );
        }
      });

      if (!baseLeadRule()) {
        console.warn(
          "[SPARC Shared V42.7] No valid Muscle Series Base lead-time rule was found."
        );
      }
    }

    delayedSync();
    scheduleResize();
    setTimeout(applyV11Polish, 150);
    setTimeout(applyV11Polish, 600);

    console.info(
      "[SPARC Shared V42.7] Structural quantity placement + " +
      "Hulk swatch media extraction active."
    );

    console.info(
      "[SPARC Shared V42.7] V40 page polish reached successfully; " +
      "Accessories extension active."
    );

    console.info(
      "[SPARC Shared V42.7] Finish media:",
      choices(refs.finish).map(function (choice) {
        return {
          value: choice.value,
          image: choice.image
        };
      })
    );

    console.info(
      "[SPARC Shared V42.7] Grip media:",
      choices(refs.grip).map(function (choice) {
        return {
          value: choice.value,
          image: choice.image
        };
      })
    );

    console.info(
      "[SPARC MUSCLE] Hulk image swatches + condition source-of-truth revision active."
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();

/* SPARC cart summary — presentation only; preserve all Hulk properties. */
(function () {
  "use strict";

  if (
    window.__SPARC_CART_SUMMARY_V425__ ||
    !/(?:^|\/)cart\/?$/.test(window.location.pathname)
  ) {
    return;
  }

  window.__SPARC_CART_SUMMARY_V425__ = true;

  var ROW = "form.cart tr.cart__row";
  var RAW = ".cart-property";
  var SUMMARY = ".sparc-cart-build";
  var timer = null;
  var signatures = new WeakMap();

  var fields = [
    {
      label: "Center Finish",
      names: ["Steering Wheel Finish", "Center Finish"]
    },
    {
      label: "Grip Style",
      names: ["Grip Style", "Grip Profile"]
    },
    {
      label: "Leather Wrap",
      names: ["Leather Wrap?"]
    },
    {
      label: "Leather Color",
      names: ["Leather Color"]
    },
    {
      label: "Stitching",
      names: ["Stitching"],
      pattern: /^Stitching(?: Color)?\s*[-–—:]/i
    },
    {
      label: "Leather Template",
      names: ["Leather Template?"]
    },
    {
      label: "Horn Logo",
      names: ["Laser Marking?", "Horn Logo?", "Horn Logo"],
      pattern: /^Horn Cap\s*[-–—:]/i
    },
    {
      label: "Adapter",
      names: ["Adapter", "Mounting Adapter"]
    },
    {
      label: "Hub Sleeve",
      names: ["Include Hub Sleeve?", "Hub Sleeve"]
    }
  ];

  function list(selector, scope) {
    return Array.prototype.slice.call(
      (scope || document).querySelectorAll(selector)
    );
  }

  function tidy(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function cleanValue(value) {
    return tidy(
      String(value || "")
        .replace(/\s*\[\s*[+\-]?\$\s*[\d,]+(?:\.\d{1,2})?\s*\]\s*/g, " ")
        .replace(/\s*\|\s*[+\-]?\$\s*[\d,]+(?:\.\d{1,2})?\s*\|\s*/g, " ")
        .replace(/\s*\(\s*[+\-]?\$\s*[\d,]+(?:\.\d{1,2})?\s*\)\s*/g, " ")
    );
  }

  function readProperty(node) {
    var nameNode = node.querySelector(".property_name");

    if (!nameNode) {
      return null;
    }

    var key = tidy(nameNode.textContent).replace(/:\s*$/, "");
    var valueNode = node.querySelector(".property_value");
    var value;

    if (valueNode) {
      value = valueNode.textContent;
    } else {
      var copy = node.cloneNode(true);
      var copiedName = copy.querySelector(".property_name");

      if (copiedName) {
        copiedName.remove();
      }

      value = copy.textContent;
    }

    var links = list("a[href]", valueNode || node)
      .filter(function (link) {
        return !nameNode.contains(link);
      })
      .map(function (link) {
        return {
          text: tidy(link.textContent) || "View file",
          href: link.getAttribute("href")
        };
      })
      .filter(function (link) {
        return /^(?:https?:\/\/|\/)/i.test(link.href);
      });

    return {
      node: node,
      key: key,
      value: cleanValue(value),
      links: links
    };
  }

  function matches(record, field) {
    return (
      field.names.indexOf(record.key) !== -1 ||
      !!(field.pattern && field.pattern.test(record.key))
    );
  }

  function buildEntries(records) {
    if (
      !records.some(function (record) {
        return matches(record, fields[0]);
      }) ||
      !records.some(function (record) {
        return (
          matches(record, fields[1]) ||
          matches(record, fields[2]) ||
          matches(record, fields[6])
        );
      })
    ) {
      return null;
    }

    var used = new Set();
    var entries = [];
    var conflict = false;

    fields.forEach(function (field) {
      var candidates = records.filter(function (record) {
        return record.value && matches(record, field);
      });

      if (!candidates.length) {
        return;
      }

      if (candidates.some(function (record) {
        return record.value !== candidates[0].value;
      })) {
        conflict = true;
        return;
      }

      var selected = candidates.slice().sort(function (a, b) {
        var aIndex = field.names.indexOf(a.key);
        var bIndex = field.names.indexOf(b.key);

        return (
          (aIndex < 0 ? 100 : aIndex) -
          (bIndex < 0 ? 100 : bIndex)
        );
      })[0];

      candidates.forEach(function (record) {
        used.add(record);
      });

      var display = selected.value;

      if (field.label === "Leather Wrap" && display === "None (raw finish)") {
        display = "No";
      }

      if (field.label === "Horn Logo" && display === "Sparc Logo Delete") {
        display = "Logo Delete";
      }

      if (field.label === "Horn Logo" && display === "Sparc Logo") {
        display = "SPARC Logo";
      }

      entries.push({
        label: field.label,
        value: display,
        links: selected.links
      });
    });

    if (conflict) {
      return null;
    }

    records.forEach(function (record) {
      if (
        !used.has(record) &&
        record.key &&
        record.key.charAt(0) !== "_" &&
        (record.value || record.links.length)
      ) {
        entries.push({
          label: record.key,
          value: record.value,
          links: record.links
        });
      }
    });

    return entries;
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);

    if (className) {
      node.className = className;
    }

    if (text !== undefined) {
      node.textContent = text;
    }

    return node;
  }

  function restore(row) {
    list(RAW, row).forEach(function (node) {
      node.classList.remove("sparc-cart-property-source");
    });

    list(SUMMARY, row).forEach(function (node) {
      node.remove();
    });

    row.classList.remove("sparc-cart-build-row");
    signatures.delete(row);
  }

  function renderRow(row) {
    var meta = row.querySelector(".cart__table-cell--meta");

    if (!meta) {
      return;
    }

    var records = list(RAW, meta).map(readProperty).filter(Boolean);
    var entries = buildEntries(records);

    if (!entries || !entries.length) {
      if (row.classList.contains("sparc-cart-build-row")) {
        restore(row);
      }

      return;
    }

    var signature = JSON.stringify(entries);
    var summary = meta.querySelector(SUMMARY);

    if (!summary || signatures.get(row) !== signature) {
      var next = element("section", "sparc-cart-build");
      next.setAttribute("aria-label", "Selected configuration");

      next.appendChild(
        element("p", "sparc-cart-build__heading", "YOUR CONFIGURATION")
      );

      var descriptionList = element("dl", "sparc-cart-build__list");

      entries.forEach(function (entry) {
        var pair = element("div", "sparc-cart-build__option");
        pair.appendChild(element("dt", "", entry.label));

        var description = element("dd", "", entry.value);

        entry.links.forEach(function (link) {
          var anchor = element("a", "sparc-cart-build__file", link.text);
          anchor.href = link.href;
          anchor.target = "_blank";
          anchor.rel = "noopener noreferrer";
          description.appendChild(anchor);
        });

        pair.appendChild(description);
        descriptionList.appendChild(pair);
      });

      next.appendChild(descriptionList);

      if (summary) {
        summary.replaceWith(next);
      } else {
        meta.insertBefore(next, records[0].node);
      }

      signatures.set(row, signature);
    }

    records.forEach(function (record) {
      record.node.classList.add("sparc-cart-property-source");
    });

    row.classList.add("sparc-cart-build-row");
  }

  function update() {
    timer = null;
    list(ROW).forEach(renderRow);
  }

  function schedule() {
    if (timer === null) {
      timer = window.setTimeout(update, 60);
    }
  }

  function relevant(node) {
    var target = node.nodeType === 1 ? node : node.parentElement;

    return !!(
      target &&
      !target.closest(SUMMARY) &&
      (
        target.matches(RAW) ||
        target.closest(RAW) ||
        target.querySelector(RAW)
      )
    );
  }

  function start() {
    if (!document.getElementById("sparc-cart-summary-style")) {
      var style = element("style");
      style.id = "sparc-cart-summary-style";

      style.textContent = [
        "form.cart .cart-property.sparc-cart-property-source{display:none!important}",
        "form.cart .sparc-cart-build{margin:16px 0 18px;padding:16px 18px;border:1px solid #e6e2db;border-radius:10px;background:#faf9f6;color:#292929;text-align:left;max-width:540px}",
        "form.cart .sparc-cart-build__heading{margin:0 0 10px;font-size:10px;line-height:1.4;letter-spacing:.14em;font-weight:700;color:#806c4d}",
        "form.cart .sparc-cart-build__list{margin:0;padding:0}",
        "form.cart .sparc-cart-build__option{display:grid;grid-template-columns:112px minmax(0,1fr);gap:6px 14px;margin:0;padding:5px 0;font-size:13px;line-height:1.5}",
        "form.cart .sparc-cart-build__option dt{margin:0;padding:0;font-weight:400;color:#6a655e;overflow-wrap:anywhere}",
        "form.cart .sparc-cart-build__option dd{margin:0;padding:0;font-weight:600;color:#292929;overflow-wrap:anywhere}",
        "form.cart .sparc-cart-build__file{display:block;margin-top:3px;text-decoration:underline;text-underline-offset:3px}",
        "form.cart .sparc-cart-build-row>td{vertical-align:top;padding-top:24px;padding-bottom:24px}",
        "form.cart .sparc-cart-build-row .cart__table-cell--meta>p:first-child{margin-bottom:0;font-size:19px;font-weight:600}",
        "@media(max-width:749px){form.cart .sparc-cart-build{max-width:none;margin:14px 0;padding:14px}form.cart .sparc-cart-build__option{grid-template-columns:100px minmax(0,1fr);gap:6px 10px;font-size:13px}form.cart .sparc-cart-build-row>td{padding-top:12px;padding-bottom:12px}}"
      ].join("\n");

      document.head.appendChild(style);
    }

    update();

    var observer = new MutationObserver(function (changes) {
      var shouldUpdate = changes.some(function (change) {
        if (
          change.type === "characterData" ||
          change.type === "attributes"
        ) {
          return relevant(change.target);
        }

        if (
          change.target.nodeType === 1 &&
          change.target.closest(RAW)
        ) {
          return true;
        }

        return (
          Array.prototype.some.call(change.addedNodes, relevant) ||
          Array.prototype.some.call(change.removedNodes, relevant)
        );
      });

      if (shouldUpdate) {
        schedule();
      }
    });

    observer.observe(document.getElementById("MainContent") || document.body, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["href"]
    });

    document.addEventListener("shopify:section:load", schedule);
    window.addEventListener("pageshow", schedule);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();